window.__VOGRACE__ = window.__VOGRACE__ = {};
window.__VOGRACE_LOADING__ = new Map();
window.__VOGRACE_POPUP__ = new Map();
window.__VOGRACE_SLIDER__ = new Map();
window.__VOGRACE_COUNTER__ = new Map();

window.VOGRACE = window.__VOGRACE__;

window.navigateToCartOrOpenCartDrawer =
  function VG_navigateToCartOrOpenCartDrawer() {
    if (window.theme.settings.cartType === "drawer") {
      // 打开购物车抽屉前，隐藏全局loading
      window.closeLoading && window.closeLoading();

      window.__VOGRACE__.eventBus.emit("vograce:cart-drawer:open", {
        refresh: true,
      });
    } else {
      window.location.href = window.theme.routes.cartPage;
    }
  };

/**
 * 图标组件
 *
 * @param {IconName} name 图标名称
 * @returns {string}
 */
window.__VOGRACE__.Icon = function VG_Icon(name) {
  const svg = {
    close:
      '<path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>',
    left: '<path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>',
    right:
      '<path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>',
    down: '<path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>',
    plus: '<path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>',
    minus:
      '<path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>',
    "check-circle":
      '<path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>',
    search:
      '<path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>',
    loading:
      '<path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>',
  };

  if (name === "delete") {
    return `
      <span role="img" class="vograce-icon vograce-icon--${name}" aria-label="${name}">
        <svg
          viewBox="0 0 24 24"
          focusable="false"
          data-icon="${name}"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M18.7313 20.4936C18.7313 21.2998 18.075 21.9561 17.2687 21.9561H6.73125C5.925 21.9561 5.26875 21.2998 5.26875 20.4936V4.96855H18.7313V20.4936ZM8.19375 2.34355C8.19375 2.1748 8.325 2.04355 8.49375 2.04355H15.525C15.6938 2.04355 15.825 2.1748 15.825 2.34355V3.2248H8.19375V2.34355ZM23.1188 3.2248H17.5687V2.34355C17.5687 1.21853 16.65 0.299805 15.525 0.299805H8.49375C7.36875 0.299805 6.45 1.21853 6.45 2.34355V3.2248H0.88125C0.39375 3.2248 0 3.61855 0 4.10605C0 4.59355 0.39375 4.9873 0.88125 4.9873H3.50625V20.4936C3.50625 22.2748 4.95 23.7186 6.73125 23.7186H17.2687C19.05 23.7186 20.4938 22.2748 20.4938 20.4936V4.96855H23.1188C23.6063 4.96855 24 4.5748 24 4.0873C24 3.5998 23.6063 3.2248 23.1188 3.2248ZM12 19.3123C12.4875 19.3123 12.8812 18.9186 12.8812 18.4311V9.05605C12.8812 8.56855 12.4875 8.1748 12 8.1748C11.5125 8.1748 11.1187 8.56855 11.1187 9.05605V18.4311C11.1187 18.9186 11.5125 19.3123 12 19.3123ZM7.89375 19.3123C8.38125 19.3123 8.775 18.9186 8.775 18.4311V9.05605C8.775 8.56855 8.38125 8.1748 7.89375 8.1748C7.40625 8.1748 7.0125 8.56855 7.0125 9.05605V18.4311C7.03125 18.9186 7.425 19.3123 7.89375 19.3123ZM16.1063 19.3123C16.5938 19.3123 16.9875 18.9186 16.9875 18.4311V9.05605C16.9875 8.56855 16.5938 8.1748 16.1063 8.1748C15.6188 8.1748 15.225 8.56855 15.225 9.05605V18.4311C15.225 18.9186 15.6188 19.3123 16.1063 19.3123Z" />
        </svg>
      </span>
    `;
  }

  return `
    <span role="img" class="vograce-icon vograce-icon--${name}" aria-label="${name}">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="${name}" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        ${svg[name]}
      </svg>
    </span>
  `;
};

/**
 * 沙盒模式
 *
 * @param {(instance: VGSDKWithComponents) => void} callback
 */
window.__VOGRACE__.sandbox = function VG_sandbox(callback) {
  try {
    this.isFunction(callback) && callback(this);
  } catch (error) {
    this.logger.error(error);
  }
};

/**
 * 等待文档加载完成后执行回调函数
 *
 * @param {() => void} callback 回调函数
 */
window.__VOGRACE__.ready = function VG_ready(callback) {
  // 如果文档状态为 `loading`，表示 DOM 正在加载
  if (document.readyState === "loading") {
    // 添加事件监听器，当 DOM 加载完成时触发 `DOMContentLoaded` 事件，然后执行回调函数 callback
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    // 如果文档状态不是 `loading`，说明 DOM 已经加载完成
    // 防止文档已加载完成但事件已被触发的情况
    // 直接执行回调函数 callback，确保期望的回调行为得以执行
    callback();
  }
};

/**
 * 获取元素
 *
 * @param {string} selector 选择器
 * @param {HTMLElement | Document} [context=document] 上下文
 * @returns {HTMLElement} 元素
 */
window.__VOGRACE__.$ = function VG_$(selector, context = document) {
  return context.querySelector(selector);
};

/**
 * 获取元素列表
 *
 * @param {string} selector 选择器
 * @param {HTMLElement | Document} [context=document] 上下文
 * @returns {NodeListOf<HTMLElement>} 元素列表
 */
window.__VOGRACE__.$$ = function VG_$$(selector, context = document) {
  return context.querySelectorAll(selector);
};

/**
 * 获取元素的兄弟元素
 *
 * @param {HTMLElement} element 当前元素
 * @param {string} selector 选择器
 * @returns {HTMLElement | null} 兄弟元素
 */
window.__VOGRACE__.getSiblingElement = function VG_getSiblingElement(
  element,
  selector
) {
  let sibling = element.parentNode.firstChild;

  while (sibling) {
    // 只匹配指定类型为 ELEMENT_NODE 的节点（跳过文本节点等）
    if (sibling.nodeType === 1 && sibling !== element) {
      // 使用 matches 方法判断是否符合传入的选择器
      if (sibling instanceof HTMLElement && sibling.matches(selector)) {
        return sibling;
      }
    }
    sibling = sibling.nextSibling;
  }

  return null;
};

/**
 * 创建元素
 *
 * @param {string} tagName 标签名
 * @param {Record<string, string>} [attributes={}] 属性
 * @param {Array<HTMLElement> | Element | string} [children=[]] 子元素
 * @returns {HTMLElement} 元素
 */
window.__VOGRACE__.createElement = function VG_createElement(
  tagName,
  attributes = {},
  children = []
) {
  const element = document.createElement(tagName);

  if (attributes) {
    Object.keys(attributes).forEach((key) => {
      if (key === "data" && this.isObject(attributes.data)) {
        Object.keys(attributes.data).forEach((key) => {
          element.dataset[key] = attributes.data[key];
        });
      } else if (key === "aria") {
        Object.keys(attributes.aria).forEach((key) => {
          element.setAttribute(`aria-${key}`, attributes.aria[key]);
        });
      } else if (key === "style" && this.isObject(attributes.style)) {
        Object.keys(attributes.style).forEach((key) => {
          element.style[key] = attributes.style[key];
        });
      } else {
        element.setAttribute(key, attributes[key]);
      }
    });
  }

  if (this.isArray(children)) {
    children.forEach((child) => {
      element.appendChild(child);
    });
  } else {
    element.innerHTML = children.toString();
  }

  return element;
};

/**
 * 启用页面滚动功能
 *
 * 该函数通过清除body元素的overflow样式来恢复页面的默认滚动行为。
 * 通常用于取消之前设置的overflow:hidden样式，使页面重新获得滚动能力。
 */
window.__VOGRACE__.enablePageScroll = function VG_enablePageScroll() {
  document.body.style.overflow = "";
};

/**
 * 禁用页面滚动功能
 *
 * 该函数通过设置body元素的overflow样式为hidden来禁用页面的滚动功能，
 * 通常用于模态框或弹出层显示时防止背景页面滚动
 */
window.__VOGRACE__.disablePageScroll = function VG_disablePageScroll() {
  document.body.style.overflow = "hidden";
};

/**
 * 隐藏元素
 *
 * @param {HTMLElement} element 元素
 */
window.__VOGRACE__.show = function VG_show(element) {
  element.setAttribute("data-visibility", "visible");
};

/**
 * 隐藏元素
 *
 * @param {HTMLElement} element 元素
 */
window.__VOGRACE__.hide = function VG_hide(element) {
  element.setAttribute("data-visibility", "hidden");
};

/**
 * 添加类名
 *
 * @param {HTMLElement} element 元素
 */
window.__VOGRACE__.addClass = function VG_addClass(element) {
  if (arguments.length === 1) return;
  const classes = Array.prototype.slice.call(arguments, 1);
  element.classList.add.apply(element.classList, classes);
};

/**
 * 移除类名
 *
 * @param {HTMLElement} element 元素
 */
window.__VOGRACE__.removeClass = function VG_removeClass(element) {
  if (arguments.length === 1) return;
  const classes = Array.prototype.slice.call(arguments, 1);
  element.classList.remove.apply(element.classList, classes);
};

/**
 * 判断元素是否包含某个类名
 *
 * @param {HTMLElement} element 元素
 * @param {string} className 类名
 * @return {boolean}
 */
window.__VOGRACE__.hasClass = function VG_hasClass(element, className) {
  return element.classList.contains(className);
};

/**
 * 获取元素属性
 *
 * @param {HTMLElement} element 元素
 * @param {string} attributeName 属性名
 * @return {string}
 */
window.__VOGRACE__.getAttribute = function VG_getAttribute(
  element,
  attributeName
) {
  return element.getAttribute(attributeName);
};

/**
 * 设置元素属性
 *
 * @param {HTMLElement} element 元素
 * @param {string} attributeName 属性名
 * @param {string} attributeValue 属性值
 */
window.__VOGRACE__.setAttribute = function VG_setAttribute(
  element,
  attributeName,
  attributeValue
) {
  element.setAttribute(attributeName, attributeValue);
};

/**
 * 获取元素属性
 *
 * @param {HTMLElement} element 元素
 * @param {string} key 属性名
 * @param {string | number} [value] 属性值
 * @returns {string} 属性值
 */
window.__VOGRACE__.dataset = function VG_dataset(element, key, value) {
  if (this.isUndefined(value) || this.isNull(value)) {
    return element.dataset[key];
  }
  element.dataset[key] = value.toString();
};

/**
 * 转义 HTML 字符
 *
 * @param {string} str 要转义的字符串
 * @returns {string} 转义后的字符串
 */
window.__VOGRACE__.escapeHtml = function VG_escapeHtml(str) {
  if (!this.isString(str)) return str;

  const map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
  };

  return str.replace(/[&<>"'\/]/g, function (s) {
    return map[s];
  });
};

/**
 * 将文本中的换行符转换为 HTML br 标签
 *
 * @param {string} text 要转换的文本
 * @returns {string} 转换后的 HTML
 */
window.__VOGRACE__.nl2br = function VG_nl2br(text) {
  if (!this.isString(text)) return text;
  return text.replace(/\r\n|\n\r|\n|\r/g, "<br>");
};

/**
 * 为指定的选择器绑定点击事件监听器
 *
 * @param {string|HTMLElement|Document|Window} selector - 选择器或元素
 * @param {string} event - 事件类型
 * @param {EventListenerOrEventListenerObject} handler - 点击事件触发时执行的回调函数
 * @param {boolean | AddEventListenerOptions} [options] - 事件选项
 */
window.__VOGRACE__.on = function VG_on(selector, event, handler, options) {
  // 如果 selector 是字符串，则使用 $ 函数查询元素
  if (this.isString(selector)) {
    const element = this.$(selector);
    if (element) {
      element.addEventListener(event, handler, options);
    } else {
      this.logger.warn(`Element with selector "${selector}" not found.`);
    }
  } else {
    selector.addEventListener(event, handler, options);
  }
};

/**
 * 为指定的选择器移除点击事件监听器
 *
 * @param {string|HTMLElement|Document|Window} selector - 选择器或元素
 * @param {string} event - 事件类型
 * @param {EventListenerOrEventListenerObject} handler - 点击事件触发时执行的回调函数
 *
 */
window.__VOGRACE__.off = function VG_off(selector, event, handler) {
  if (this.isString(selector)) {
    const element = this.$(selector);
    if (element) {
      element.removeEventListener(event, handler);
    } else {
      this.logger.warn(`Element with selector "${selector}" not found.`);
    }
  } else {
    selector && selector.removeEventListener(event, handler);
  }
};

/**
 * 判断是否是移动端（基于媒体查询，可自定义断点）
 *
 * @param {number} [breakpoint=767] 断点值（像素）
 * @returns {boolean} 是否是移动端
 */
window.__VOGRACE__.isMobile = function VG_isMobile(breakpoint = 767) {
  return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
};

/**
 * 空函数
 */
window.__VOGRACE__.noop = function VG_noop() {};

/**
 * 判断是否是 undefined
 *
 * @param {unknown} val 值
 * @returns {val is undefined} 是否是 undefined
 */
window.__VOGRACE__.isUndefined = function VG_isUndefined(val) {
  return val === void 0;
};

/**
 * 判断是否是字符串
 *
 * @param {unknown} val 值
 * @returns {val is string} 是否是字符串
 */
window.__VOGRACE__.isString = function VG_isString(val) {
  return typeof val === "string";
};

/**
 * 判断是否是数字
 *
 * @param {unknown} val 值
 * @return {val is number} 是否是数字
 */
window.__VOGRACE__.isNumber = function VG_isNumber(val) {
  return typeof val === "number";
};

/**
 * 判断是否是布尔值
 *
 * @param {unknown} val 值
 * @return {val is boolean} 是否是布尔值
 */
window.__VOGRACE__.isBoolean = function VG_isBoolean(val) {
  return typeof val === "boolean";
};

/**
 * 判断是否是 null
 *
 * @param {unknown} val 值
 * @returns {val is null} 是否是 null
 */
window.__VOGRACE__.isNull = function VG_isNull(val) {
  return val === null;
};

/**
 * 判断是否是数组
 *
 * @param {unknown} val 值
 * @returns {val is unknown[]} 是否是数组
 */
window.__VOGRACE__.isArray = function VG_isArray(val) {
  return Array.isArray(val);
};

/**
 * 判断是否是对象
 *
 * @param {unknown} val 值
 * @returns {val is Record<string, unknown>} 是否是对象
 */
window.__VOGRACE__.isObject = function VG_isObject(val) {
  return !this.isNull(val) && typeof val === "object";
};

/**
 * 判断是否是对象
 *
 * @param {unknown} val 值
 * @returns {val is Function} 是否是函数
 */
window.__VOGRACE__.isFunction = function VG_isFunction(val) {
  return typeof val === "function";
};

/**
 * 等待指定时间
 *
 * @param {number} ms - 等待的时间，以毫秒为单位
 */
window.__VOGRACE__.wait = function VG_wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * 应用 CSS 样式
 *
 * @param {HTMLElement} element - 要应用样式的元素
 * @param {string | CSSProperties} styles - 要应用的 CSS 样式
 */
window.__VOGRACE__.css = function VG_css(element, styles) {
  // 检查元素是否存在
  if (!element) {
    this.logger.warn("Invalid element provided to css function");
    return;
  }

  // 如果样式是字符串类型
  if (this.isString(styles)) {
    // 直接设置CSS文本
    element.style.cssText = styles;
    return;
  }

  // 如果样式是对象类型
  if (this.isObject(styles)) {
    // 遍历对象中的每个样式属性
    Object.keys(styles).forEach((property) => {
      let value = styles[property];
      value = this.isNumber(value) ? value + "px" : value;

      // 处理样式属性名，将驼峰命名转换为短横线命名
      const kebabCaseProperty = property.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);

      // 设置样式
      element.style.setProperty(kebabCaseProperty, value);
    });
    return;
  }

  this.logger.warn("Invalid styles provided to css function. Expected string or object.");
};

/**
 * 获取元素在页面中的位置信息
 *
 * @param {HTMLElement} element
 * @returns {DOMRect}
 */
window.__VOGRACE__.getRect = function VG_getRect(element) {
  return element.getBoundingClientRect();
};

/**
 * 获取页面滚动位置
 *
 * @returns {number}
 */
window.__VOGRACE__.getScrollTop = function VG_getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop;
};

/**
 * 防抖函数
 *
 * @template {Function} T
 * @param {T} fn 要执行的函数
 * @param {number} delay 延迟时间（毫秒）
 * @returns {(...args: unknown[]) => void} 包裹后的防抖函数
 */
window.__VOGRACE__.debounce = function VG_debounce(fn, delay) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), delay);
  };
};

/**
 * 节流函数
 *
 * @template {Function} T
 * @param {T} fn 要执行的函数
 * @param {number} delay 执行间隔时间（毫秒）
 * @returns {(...args: unknown[]) => void} 包裹后的节流函数
 */
window.__VOGRACE__.throttle = function VG_throttle(fn, delay) {
  let lastCall = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    }
  };
};

/**
 * 显示弹窗
 *
 * @param {PopupOptions} options 弹窗参数
 */
window.__VOGRACE__.showPopup = function VG_showPopup(options) {
  const {
    id,
    width = 750,
    title,
    content,
    showCancelButton = false,
    cancelButtonText = "Cancel",
    showConfirmButton = true,
    confirmButtonText = "Confirm",
    buildConfirmButton,
    buildCancelButton,
    onCancel = this.noop,
    onClose = this.noop,
    onConfirm = this.noop,
  } = options;

  let html = "";
  let root;
  let cancelButton;
  let confirmButton;

  if (title) {
    html += `<h2 class="vograce-typography vograce-popup__title">${title}</h2>`;
  }

  if (content) {
    html += this.isString(content) ? content : content.outerHTML;
  }

  if (showCancelButton || showConfirmButton) {
    const buttons = this.createElement("div", {
      class: "vograce-flex vograce-flex-center vograce-popup__buttons",
    });

    if (showCancelButton) {
      cancelButton = this.isFunction(buildCancelButton)
        ? buildCancelButton()
        : this.createElement(
            "button",
            {
              type: "button",
              class: [
                "vograce-button",
                "vograce-button--primary",
                "vograce-button--outlined",
                "vograce-popup__button",
              ].join(" "),
              data: {
                action: "cancel",
              },
            },
            cancelButtonText
          );

      buttons.appendChild(cancelButton);
    }

    if (showConfirmButton) {
      confirmButton = this.isFunction(buildConfirmButton)
        ? buildConfirmButton()
        : this.createElement(
            "button",
            {
              type: "button",
              class: [
                "vograce-button",
                "vograce-button--primary",
                "vograce-button--solid",
                "vograce-popup__button",
              ].join(" "),
              data: {
                action: "confirm",
              },
            },
            confirmButtonText
          );

      buttons.appendChild(confirmButton);
    }

    html += buttons.outerHTML;
  }

  root = this.createElement(
    "div",
    {
      id: `VogracePopup-${id}`,
      class: "vograce-popup vograce-popup--confirm",
      data: {
        visibility: "visible",
      },
    },
    `
      <div class="vograce-overlay vograce-popup__overlay" data-dismiss="popup"></div>
      <div class="vograce-popup__content" style="width: ${
        this.isMobile() ? `100vw` : this.isNumber(width) ? `${width}px` : width
      }">
        <div class="vograce-popup__body" role="dialog">
          <button type="button" class="vograce-close-button" data-dismiss="popup" aria-label="close">
            <span role="img" class="vograce-icon vograce-icon--close" aria-label="close">
              <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                <path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
              </svg>
            </span>
          </button>
          ${html}
        </div>
      </div>
    `
  );

  const close = () => {
    this.isMobile() && this.enablePageScroll();
    this.hide(root);
    this.off(root, "click", clickHandler);
    root.remove();
    this.enablePageScroll();
  };

  const cancel = () => {
    onCancel(close);
  };

  const confirm = () => {
    onConfirm(close);
  };

  const clickHandler = (e) => {
    // 处理关闭按钮
    const closeTarget = e.target.closest('[data-dismiss="popup"]');
    if (closeTarget) {
      close();
      onClose();
      return;
    }

    // 处理取消按钮
    const cancelTarget = e.target.closest('[data-action="cancel"]');
    if (cancelTarget) {
      cancel();
      return;
    }

    // 处理确认按钮
    const confirmTarget = e.target.closest('[data-action="confirm"]');
    if (confirmTarget) {
      confirm();
      return;
    }
  };

  this.disablePageScroll();
  this.on(root, "click", clickHandler);
  this.isMobile() && this.disablePageScroll();
  document.body.appendChild(root);
};

/**
 * 显示抽屉
 *
 * @param {DrawerOptions} options 抽屉参数
 */
window.__VOGRACE__.showDrawer = function VG_showDrawer(options) {
  if (!this.isObject(options)) {
    this.logger.error("showDrawer options must be an object.");
    throw new Error("showDrawer options must be an object.");
  }

  const { id, title, content, width = 500 } = options;

  let html = "";
  let root;

  if (title) {
    html += `<h2 class="vograce-drawer__title">${title}</h2>`;
  }

  if (content) {
    html += this.isString(content) ? content : content.outerHTML;
  }

  root = this.createElement(
    "div",
    {
      id: `VograceDrawer-${id}`,
      class: "vograce-drawer vograce-drawer--right",
      data: {
        visibility: "visible",
      },
    },
    `
      <div class="vograce-overlay vograce-drawer__overlay" data-dismiss="drawer"></div>
      <div class="vograce-drawer__content" style="width: ${
        this.isMobile() ? `100vw` : this.isNumber(width) ? `${width}px` : width
      }">
        <button type="button" class="vograce-close-button" data-dismiss="drawer" aria-label="close">
          <span role="img" class="vograce-icon vograce-icon--close" aria-label="close">
            <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
            </svg>
          </span>
        </button>
        ${html}
      </div>
    `
  );

  const clickHandler = (e) => {
    // 处理关闭按钮
    const closeTarget = e.target.closest('[data-dismiss="drawer"]');
    if (!closeTarget) return;

    this.removeClass(root, "vograce-drawer--open");
    this.enablePageScroll();
    setTimeout(() => {
      this.hide(root);
      this.off(root, "click", clickHandler);
      root.remove();
    }, 300);
  };

  this.on(root, "click", clickHandler);
  document.body.appendChild(root);

  setTimeout(() => {
    this.addClass(root, "vograce-drawer--open");
    this.disablePageScroll();
  }, 100);
};

/**
 * 显示加载动画
 *
 * @param {LoadingOptions} options 显示加载动画的选项
 * @returns {() => void}
 */
window.__VOGRACE__.showLoading = function VG_showLoading({
  target = document.body,
  overlay = true,
  inside = false,
  size = 48,
  color = "var(--vograce-color-primary)",
  text = "Loading...",
}) {
  if (window.__VOGRACE_LOADING__.has(target)) {
    // const container = window.__VOGRACE_LOADING__.get(target);
    // const element = this.$(".vograce-loading__text", container);
    // element.textContent = text;
    return;
  }

  const sizing = this.isNumber(size) ? `${size}px` : size;
  const container = this.createElement("div", { class: "vograce-loading" });
  container.innerHTML = `
    ${inside || overlay ? '<div class="vograce-loading__overlay"></div>' : ""}
    <div class="vograce-loading__content" style="font-size: ${sizing}; color: ${color};">
      <span role="img" class="vograce-loading__spinner" aria-label="loading">
        <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
        </svg>
      </span>
      <span class="vograce-loading__text">${text}</span>
    </div>
  `;

  target.appendChild(container);

  const hide = () => {
    container.remove();
  };

  window.__VOGRACE_LOADING__.set(target, container);

  return hide;
};

/**
 * 隐藏加载动画
 *
 * @param {HTMLElement} target 目标元素
 */
window.__VOGRACE__.hideLoading = function VG_hideLoading(target) {
  if (!window.__VOGRACE_LOADING__.has(target)) return;

  window.__VOGRACE_LOADING__.get(target).remove();
  window.__VOGRACE_LOADING__.delete(target);
};

/**
 * 显示登录弹窗
 */
window.__VOGRACE__.showLoginPopup = function VG_showLoginPopup() {
  const popup = window.__VOGRACE_POPUP__.get("#AuthDialog");
  popup.open();
  this.eventBus.emit("auth:login");
};

/**
 * 显示新版编辑器弹窗
 */
window.__VOGRACE__.showAddMethodPopup = function showAddMethodPopup() {
  const popup = window.__VOGRACE_POPUP__.get("#AddMethodDialog");
  popup.open();
  this.eventBus.emit("add-method:open");
};

/**
 * 显示注册弹窗
 */
window.__VOGRACE__.showRegisterPopup = function VG_showRegisterPopup() {
  const popup = window.__VOGRACE_POPUP__.get("#AuthDialog");
  popup.open();
  this.eventBus.emit("auth:register");
};

/**
 * 日志类
 */
window.__VOGRACE__.logger = {
  /**
   * 日志打印
   *
   * @param {...any} args 参数
   */
  info: function VG_info(...args) {
    console.info("INFO:", ...args);
  },

  /**
   * 错误日志打印
   *
   * @param {...any} args 参数
   */
  error: function VG_error(...args) {
    console.error("ERROR:", ...args);
  },

  /**
   * 警告日志打印
   *
   * @param {...any} args 参数
   */
  warn: function VG_warn(...args) {
    console.warn("WARN:", ...args);
  },

  /**
   * 调试日志打印
   *
   * @param {...any} args 参数
   */
  debug: function VG_debug(...args) {
    console.debug("DEBUG:", ...args);
  },
};

/**
 * ======================================
 * ======= Fetch
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  class InterceptorManager {
    constructor() {
      this.handlers = [];
    }

    use(fulfilled, rejected) {
      this.handlers.push({ fulfilled, rejected });
      return this.handlers.length - 1;
    }

    eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    }

    forEach(fn) {
      this.handlers.forEach((h) => {
        if (h !== null) {
          fn(h);
        }
      });
    }

    clear() {
      this.handlers = [];
    }
  }

  class VGFetch {
    constructor() {
      this.defaults = {
        baseUrl: "",
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 10000,
      };
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager(),
      };
      this.requestMap = new Map();
    }

    async request(config) {
      const fullConfig = this._mergeConfig(config);
      const key = `${fullConfig.method}:${fullConfig.url}`; // 生成请求唯一标识符

      if (this.requestMap.has(key)) {
        _.logger.warn(`[${key}] 请求正在处理中...`);
        return this.requestMap.get(key);
      }

      // 触发请求拦截器
      let promise = Promise.resolve(fullConfig);
      const chain = [];

      this.interceptors.request.forEach((interceptor) => {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
      });

      chain.push(this._fetchAdapter.bind(this), undefined); // 使用 fetch 作为适配器

      while (chain.length) {
        const onFulfilled = chain.shift();
        const onRejected = chain.shift();
        promise = promise.then(onFulfilled, onRejected);
      }

      // 存储当前请求的 Promise
      this.requestMap.set(key, promise);

      // 请求完成后从 map 中移除
      promise = promise.finally(() => {
        this.requestMap.delete(key);
      });

      const response = await promise;

      // 触发响应拦截器
      let responsePromise = Promise.resolve(response);
      this.interceptors.response.forEach((interceptor) => {
        responsePromise = responsePromise.then(interceptor.fulfilled, interceptor.rejected);
      });

      return responsePromise;
    }

    _mergeConfig(config) {
      return {
        ...this.defaults,
        ...config,
        headers: {
          ...this.defaults.headers,
          ...(config.headers || {}),
        },
      };
    }

    async _fetchAdapter(config) {
      const controller = new AbortController();
      const signal = controller.signal;

      const timeoutId = setTimeout(() => {
        controller.abort();
      }, config.timeout);

      let body;
      if (["POST", "PUT"].includes(config.method)) {
        if (
          config.headers &&
          config.headers["Content-Type"] === "application/x-www-form-urlencoded"
        ) {
          body = config.data; // 已经是 URLSearchParams.toString() 的结果
        } else {
          body = JSON.stringify(config.data);
        }
      }

      try {
        const response = await fetch(config.url, {
          method: config.method,
          headers: config.headers,
          body,
          signal,
        });
        clearTimeout(timeoutId);
        // 检查响应有效性
        if (!response.ok) {
          const contentType = response.headers.get("Content-Type");

          // 如果响应体已被消费，直接返回错误信息
          if (response.bodyUsed) {
            throw {
              message: "Response body already consumed",
              status: response.status,
              response: response,
            };
          }

          // 创建响应副本用于读取
          const responseClone = response.clone();

          // 根据内容类型选择解析方式
          let errorData;
          if (contentType.includes("application/json")) {
            errorData = await responseClone.json();
          } else {
            errorData = await responseClone.text();
          }

          throw {
            status: response.status,
            data: errorData,
            response: response,
          };
        } else {
          return response;
        }
      } catch (error) {
        clearTimeout(timeoutId);
        throw error;
      }
    }

    /**
     * 发送 GET 请求
     *
     * @param {string} url
     * @param {FetchConfig} config
     * @returns
     */
    get(url, config = {}) {
      const buildedUrl = buildUrl(url, config);
      return this.request({ ...config, method: "GET", url: buildedUrl });
    }

    /**
     * 发送 GET JSON 请求
     *
     * @param {string} url
     * @param {FetchConfig} config
     * @returns
     */
    getJSON(url, config = {}) {
      const buildedUrl = buildUrl(url, config);
      return this.request({ ...config, method: "GET", url: buildedUrl });
    }

    /**
     * 发送 POST 请求
     *
     * @param {string} url
     * @param {any} data
     * @param {FetchConfig} config
     * @returns
     */
    post(url, data = {}, config = {}) {
      const buildedUrl = buildUrl(url, config);
      return this.request({ ...config, method: "POST", url: buildedUrl, data });
    }

    /**
     * 发送 POST JSON 请求
     *
     * @param {string} url
     * @param {any} data
     * @param {FetchConfig} config
     * @returns
     */
    postJSON(url, data = {}, config = {}) {
      const buildedUrl = buildUrl(url, config);
      return this.request({
        ...config,
        method: "POST",
        url: buildedUrl,
        data,
      });
    }

    /**
     * 发送 DELETE 请求
     *
     * @param {string} url
     * @param {FetchConfig} config
     * @returns
     */
    delete(url, config) {
      const buildedUrl = buildUrl(url, config);
      return this.request({ ...config, method: "DELETE", url: buildedUrl });
    }

    /**
     * @param {Response | string} response
     */
    async html(response) {
      let html;
      if (_.isString(response)) {
        html = response;
      } else {
        html = await response.text();
      }
      const parser = new DOMParser();
      return parser.parseFromString(html, "text/html");
    }
  }

  _.fetch = new VGFetch();

  _.fetch.interceptors.request.use(function (config) {
    config.headers = {
      ...config.headers,
      "customer-id": window.customer_id || localStorage.getItem("chat_token"),
      sign: window.customer_slat,
      timestamp: window.now_timestamp,
      "shop-domain": getShopifyDomain(config.baseUrl),
      "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return config;
  });

  _.fetch.interceptors.response.use(function (response) {
    return response;
  });

  /**
   * 构建 URL
   *
   * @param {string} url
   * @param {FetchConfig} config
   * @returns
   */
  function buildUrl(url, config) {
    if (url.startsWith("http")) return url;
    const baseUrl = config.baseUrl || getBaseUrl();
    return `${baseUrl}${url}`;
  }

  function getBaseUrl() {
    switch (window.location.hostname) {
      case "xn-ooru7az5q7qa810dn7x8fucnce02b.myshopify.com":
      case "localhost":
      case "127.0.0.1":
      case "xn-ooru7ap8r6la930dn7x8fucnc.myshopify.com":
        return "https://vograce-app-testing.baigedi.com";

      case "vograce.com":
      default:
        return "https://app.vograce.com";
    }
  }

  function getShopifyDomain(baseUrl) {
    baseUrl = baseUrl || getBaseUrl();

    switch (baseUrl) {
      case "https://vograce-app-testing.baigedi.com":
        return "vograce-dev";

      case "https://app.vograce.com":
      default:
        return "vograce";
    }
  }
});

/**
 * ======================================
 * ======= Event Bus
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  class EventBus {
    constructor() {
      this.events = {};
    }

    // 辅助方法：确保事件名存在且是一个数组
    _ensureEventArray(eventName) {
      if (!_.isString(eventName) || eventName.trim() === "") {
        throw new Error("Event name must be a non-empty string.");
      }
      if (!this.events[eventName]) {
        this.events[eventName] = [];
      }
      return this.events[eventName];
    }

    on(eventName, callback) {
      if (!_.isFunction(callback)) {
        throw new TypeError("Callback must be a function.");
      }
      this._ensureEventArray(eventName).push(callback);
    }

    off(eventName, callback) {
      const callbacks = this.events[eventName];
      if (!callbacks) return;

      let index;
      while ((index = callbacks.indexOf(callback)) !== -1) {
        callbacks.splice(index, 1);
      }

      if (callbacks.length === 0) {
        delete this.events[eventName];
      }
    }

    emit(eventName, ...args) {
      const callbacks = this.events[eventName];
      if (!callbacks) return;

      // 避免在执行期间修改原数组造成的问题
      callbacks.slice().forEach((callback) => {
        try {
          callback(...args);
        } catch (error) {
          _.logger.error(
            `Error occurred in event handler for ${eventName}:`,
            error
          );
        }
      });
    }

    once(eventName, callback) {
      if (!_.isFunction(callback)) {
        throw new TypeError("Callback must be a function.");
      }

      const onceCallback = (...args) => {
        try {
          callback(...args);
        } finally {
          this.off(eventName, onceCallback);
        }
      };

      this.on(eventName, onceCallback);
      return onceCallback;
    }

    clear() {
      this.events = {};
    }
  }

  _.eventBus = new EventBus();
});

/**
 * ======================================
 * ======= Collapse
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    ROOT: "[data-root='collapse']",
    TRIGGER: "[data-trigger='collapse']",
    ICON_CLOSED: "[data-icon='plus']",
    ICON_OPENED: "[data-icon='minus']",
  };

  const collapseTypes = {
    ACCORDION: "accordion",
  };

  class CollapseItem {
    constructor(trigger, collapseType, eventName) {
      /** @type {HTMLElement} */
      this.$trigger = trigger;
      /** @type {HTMLElement} */
      this.$triggerClosedIcon = _.$(selectors.ICON_CLOSED, this.$trigger);
      /** @type {HTMLElement} */
      this.$triggerOpenedIcon = _.$(selectors.ICON_OPENED, this.$trigger);
      /** @type {HTMLElement} */
      this.$target = _.$(this.$trigger.dataset.target);

      this.collapseType = collapseType;
      this.eventName = eventName;

      this._init();
    }

    _init() {
      this._initOpened();
      this._bindEvents();
    }

    _bindEvents() {
      _.on(this.$trigger, "click", this._toggle.bind(this));
    }

    _initOpened() {
      this._opened = this.$target.dataset.visibility === "visible";
      if (this._opened) {
        _.hide(this.$triggerClosedIcon);
        _.show(this.$triggerOpenedIcon);
      }
    }

    _toggle() {
      if (!this._opened) {
        if (this.collapseType === collapseTypes.ACCORDION) {
          _.eventBus.emit(this.eventName);
        }
        this._open();
      } else {
        this.close();
      }
    }

    _open() {
      this._opened = true;
      _.show(this.$target);
      _.show(this.$triggerOpenedIcon);
      _.hide(this.$triggerClosedIcon);
    }

    close() {
      this._opened = false;
      _.hide(this.$target);
      _.hide(this.$triggerOpenedIcon);
      _.show(this.$triggerClosedIcon);
    }
  }

  class Collapse {
    constructor(root) {
      /** @type {HTMLElement} */
      this.$root = root;

      this._init();
    }

    _init() {
      if (!this.$root) return;

      /** @type {CollapseItem[]} */
      this.controllers = [];

      const collapseType = this.$root.dataset.type;
      const eventName = `collapse:${this.$root.dataset.name}`;

      _.$$(selectors.TRIGGER, this.$root).forEach(($trigger) => {
        const controller = new CollapseItem($trigger, collapseType, eventName);
        this.controllers.push(controller);
      });

      if (collapseType === collapseTypes.ACCORDION) {
        _.eventBus.on(eventName, this._onUpdate.bind(this));
      }
    }

    _onUpdate() {
      this.controllers.forEach((controller) => {
        controller.close();
      });
    }
  }

  _.ready(() => {
    _.$$(selectors.ROOT).forEach((el) => {
      new Collapse(el);
    });
  });
});

/**
 * ======================================
 * ======= Popup
 * ======================================
 */
window.__VOGRACE__.sandbox((_) => {
  const selectors = {
    TRIGGER: "[data-trigger='popup']",
    DISMISS: "[data-dismiss='popup']",
    CONTENT: ".vograce-popup__content",
  };

  class VGPoup {
    /**
     * @constructor
     * @param {HTMLElement} $trigger 触发器元素
     * @param {string} id 对应 Popup 元素 ID
     *
     */
    constructor($trigger, id) {
      this.id = id;
      this.zIndex = 11001 + window.__VOGRACE_POPUP__.size;
      /** @type {HTMLElement} */
      this.$popup = _.$(id);
      /** @type {HTMLElement} */
      this.$trigger = $trigger;
      /** @type {HTMLElement} */
      this.$content = _.$(selectors.CONTENT, this.$popup);
      this._init();
    }

    _init() {
      this._setZIndex();
      this._bindEvents();
    }

    _setZIndex() {
      this.$popup.setAttribute("style", `z-index: ${this.zIndex}`);
    }

    _bindEvents() {
      _.on(this.$trigger, "click", this.open.bind(this));
      _.$$(selectors.DISMISS, this.$popup).forEach((el) => {
        _.on(el, "click", this.close.bind(this));
      });
    }

    open() {
      _.show(this.$popup);
      _.disablePageScroll();
      _.eventBus.emit("popup:open", this.id, this.$popup, this);
    }

    close() {
      _.hide(this.$popup);
      _.enablePageScroll();
      _.eventBus.emit("popup:close", this.id, this.$popup);
    }
  }

  _.ready(() => {
    _.$$('[data-trigger="popup"]').forEach((el) => {
      const target = el.dataset.target;
      window.__VOGRACE_POPUP__.set(target, new VGPoup(el, target));
    });
  });
});

/**
 * ======================================
 * ======= Auth Dialog
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = Object.freeze({
    signIn: "#SignIn",
    signInEmail: "#SignInEmail",
    signInPwd: "#SignInPassword",
    signUp: "#SignUp",
    signUpFirstName: "#SignUpFirstName",
    signUpLastName: "#SignUpLastName",
    signUpEmail: "#SignUpEmail",
    signUpPwd: "#SignUpPassword",
    resetPwd: "#ResetPassword",
    resetPwdEmail: "#ResetPasswordEmail",
    submitButton: ".vograce-auth-dialog__submit-button",
    submitLoading: "[data-icon='loading']",
    switchButton: ".vograce-auth-dialog__switch-button",
    forgotPwdButton: ".vograce-auth-dialog__forgot-password-button",
    errors: ".vograce-auth-dialog__errors",
  });

  const classes = {
    loading: "is--loading",
    resetSuccess: "is--reset-success",
  };

  class Auth {
    constructor() {
      /** @type {HTMLElement} */
      this.$signIn = _.$(selectors.signIn);
      /** @type {HTMLElement} */
      this.$signInForgotPwd = _.$(selectors.forgotPwdButton, this.$signIn);
      /** @type {HTMLElement} */
      this.$signInSubmit = _.$(selectors.submitButton, this.$signIn);
      /** @type {HTMLElement} */
      this.$signInLoading = _.$(selectors.submitLoading, this.$signIn);
      /** @type {HTMLElement} */
      this.$signInSwitch = _.$(selectors.switchButton, this.$signIn);
      /** @type {HTMLElement} */
      this.$signInErrors = _.$(selectors.errors, this.$signIn);
      /** @type {HTMLElement} */
      this.$signUp = _.$(selectors.signUp);
      /** @type {HTMLElement} */
      this.$signUpSubmit = _.$(selectors.submitButton, this.$signUp);
      /** @type {HTMLElement} */
      this.$signUpLoading = _.$(selectors.submitLoading, this.$signUp);
      /** @type {HTMLElement} */
      this.$signUpErrors = _.$(selectors.errors, this.$signUp);
      /** @type {HTMLElement} */
      this.$resetPwd = _.$(selectors.resetPwd);
      /** @type {HTMLElement} */
      this.$resetPwdSubmit = _.$(selectors.submitButton, this.$resetPwd);
      /** @type {HTMLElement} */
      this.$resetPwdLoading = _.$(selectors.submitLoading, this.$resetPwd);
      /** @type {HTMLElement} */
      this.$resetPwdSwitch = _.$(selectors.switchButton, this.$resetPwd);
      /** @type {HTMLElement} */
      this.$resetPwdErrors = _.$(selectors.errors, this.$resetPwd);

      this._init();
    }

    _init() {
      this._bindEvents();
    }

    _bindEvents() {
      _.eventBus.on("auth:login", this._toSignIn.bind(this));
      _.eventBus.on("auth:register", this._toSignUp.bind(this));

      _.eventBus.on("popup:open", this._onPopupOpen.bind(this));
      _.eventBus.on("popup:close", this._onPopupClose.bind(this));

      _.on(this.$signInSubmit, "click", this._signIn.bind(this));
      _.on(this.$signUpSubmit, "click", this._signUp.bind(this));
      _.on(this.$resetPwdSubmit, "click", this._resetPwd.bind(this));

      _.on(this.$signInSwitch, "click", this._toSignUp.bind(this));
      _.on(this.$signInForgotPwd, "click", this._toResetPwd.bind(this));
      _.on(this.$resetPwdSwitch, "click", this._toSignUp.bind(this));
    }

    // @ts-ignore
    _onPopupOpen(id, popup, controller) {
      this._clearFields();
      this._hideResetSuccess();
      this._hideErrors();

      const $trigger = controller.$trigger;
      const mode = $trigger.getAttribute("data-mode") || "login";
      if (mode === "login") {
        this._toSignIn();
      } else if (mode === "register") {
        this._toSignUp();
      } else {
        this._toResetPwd();
      }
    }

    // @ts-ignore
    _onPopupClose(id, popup) {
      this._clearFields();
      this._hideResetSuccess();
      this._hideErrors();
      this._toSignIn();
    }

    _clearFields() {
      const $signInEmail = /** @type {HTMLInputElement} */ (
        _.$(selectors.signInEmail)
      );
      const $signInPwd = /** @type {HTMLInputElement} */ (
        _.$(selectors.signInPwd)
      );
      const $signUpFirstName = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpFirstName)
      );
      const $signUpLastName = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpLastName)
      );
      const $signUpEmail = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpEmail)
      );
      const $signUpPwd = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpPwd)
      );
      const $resetPwdEmail = /** @type {HTMLInputElement} */ (
        _.$(selectors.resetPwdEmail)
      );

      $signInEmail.value = "";
      $signInPwd.value = "";
      $signUpFirstName.value = "";
      $signUpLastName.value = "";
      $signUpEmail.value = "";
      $signUpPwd.value = "";
      $resetPwdEmail.value = "";
    }

    _hideErrors() {
      _.hide(this.$signInErrors);
      _.hide(this.$signUpErrors);
      _.hide(this.$resetPwdErrors);
    }

    _showResetSuccess() {
      _.addClass(this.$signIn, classes.resetSuccess);
    }

    _hideResetSuccess() {
      _.removeClass(this.$signIn, classes.resetSuccess);
    }

    _toSignIn() {
      this._clearLoading();
      _.show(this.$signIn);
      _.hide(this.$signUp);
      _.hide(this.$resetPwd);
      this._hideErrors();
    }

    _toSignUp() {
      this._clearLoading();
      _.show(this.$signUp);
      _.hide(this.$signIn);
      _.hide(this.$resetPwd);
    }

    _toResetPwd() {
      this._clearLoading();
      _.show(this.$resetPwd);
      _.hide(this.$signIn);
      _.hide(this.$signUp);
    }

    _clearLoading() {
      this.loading = false;
      _.removeClass(this.$signInSubmit, classes.loading);
      _.removeClass(this.$signUpSubmit, classes.loading);
      _.removeClass(this.$resetPwdSubmit, classes.loading);
      _.hide(this.$signInLoading);
      _.hide(this.$signUpLoading);
      _.hide(this.$resetPwdLoading);
    }

    /**
     * @param {HTMLElement} btn
     * @param {HTMLElement} icon
     */
    _showLoading(btn, icon) {
      this.loading = true;
      _.addClass(btn, classes.loading);
      _.show(icon);
    }

    /**
     * @param {HTMLElement} btn
     * @param {HTMLElement} icon
     */
    _hideLoading(btn, icon) {
      this.loading = false;
      _.removeClass(btn, classes.loading);
      _.hide(icon);
    }

    async _signIn() {
      if (this.loading) return;

      const $email = /** @type {HTMLInputElement} */ (
        _.$(selectors.signInEmail)
      );
      const $pwd = /** @type {HTMLInputElement} */ (_.$(selectors.signInPwd));

      this._showLoading(this.$signInSubmit, this.$signInLoading);

      const formData = new URLSearchParams();
      formData.append("form_type", "customer_login");
      formData.append("utf8", "✓");
      formData.append("customer[email]", $email.value);
      formData.append("customer[password]", $pwd.value);

      const payload = formData.toString();
      try {
        const response = await _.fetch.post("/account/login", payload, {
          baseUrl: window.location.origin,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        this._hideLoading(this.$signInSubmit, this.$signInLoading);

        const doc = await _.fetch.html(response);
        const $form = _.$("#CustomerLoginForm", doc);
        if ($form) {
          const $errors = _.$$(".errors ul li", $form);
          if ($errors && $errors.length > 0) {
            const $list = _.createElement("ul");
            Array.from($errors).forEach((item) => {
              const message = item.textContent.trim();
              const $item = _.createElement("li", null, message);
              $list.appendChild($item);
            });
            this.$signInErrors.innerHTML = "";
            this.$signInErrors.appendChild($list);
            _.show(this.$signInErrors);
            return;
          }
        }

        window.location.reload();
      } catch (error) {
        this._hideLoading(this.$signInSubmit, this.$signInLoading);
      }
    }

    async _signUp() {
      if (this.loading) return;

      const $firstName = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpFirstName)
      );
      const $lastName = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpLastName)
      );
      const $email = /** @type {HTMLInputElement} */ (
        _.$(selectors.signUpEmail)
      );
      const $pwd = /** @type {HTMLInputElement} */ (_.$(selectors.signUpPwd));

      this._showLoading(this.$signUpSubmit, this.$signUpLoading);

      const formData = new URLSearchParams();
      formData.append("form_type", "create_customer");
      formData.append("utf8", "✓");
      formData.append("customer[first_name]", $firstName.value);
      formData.append("customer[last_name]", $lastName.value);
      formData.append("customer[email]", $email.value);
      formData.append("customer[password]", $pwd.value);

      const payload = formData.toString();
      try {
        const response = await _.fetch.post("/account", payload, {
          baseUrl: window.location.origin,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        this._hideLoading(this.$signUpSubmit, this.$signUpLoading);

        const doc = await _.fetch.html(response);
        const $form = _.$("#CreateCustomerForm", doc);
        if ($form) {
          const $errors = _.$$(".errors ul li", $form);
          if ($errors && $errors.length > 0) {
            const $list = _.createElement("ul");
            Array.from($errors).forEach((item) => {
              const message = item.textContent.trim();
              const $item = _.createElement("li", null, message);
              $list.appendChild($item);
            });
            this.$signUpErrors.innerHTML = "";
            this.$signUpErrors.appendChild($list);
            _.show(this.$signUpErrors);
            return;
          }
        }

        window.location.href = response.url;
      } catch (error) {
        this._hideLoading(this.$signUpSubmit, this.$signUpLoading);
      }
    }

    async _resetPwd() {
      if (this.loading) return;

      const $email = /** @type {HTMLInputElement} */ (
        _.$(selectors.resetPwdEmail)
      );

      this._showLoading(this.$resetPwdSubmit, this.$resetPwdLoading);

      const formData = new URLSearchParams();
      formData.append("form_type", "recover_customer_password");
      formData.append("utf8", "✓");
      formData.append("email", $email.value);

      const payload = formData.toString();
      try {
        const response = await _.fetch.post("/account/recover", payload, {
          baseUrl: window.location.origin,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        this._hideLoading(this.$resetPwdSubmit, this.$resetPwdLoading);

        const doc = await _.fetch.html(response);
        const $form = _.$("#RecoverPasswordForm", doc);
        if (!$form.classList.contains("hide")) {
          const $errors = _.$$(".errors ul li", $form);
          if ($errors && $errors.length > 0) {
            const $list = _.createElement("ul");
            Array.from($errors).forEach((item) => {
              const message = item.textContent.trim();
              const $item = _.createElement("li", null, message);
              $list.appendChild($item);
            });
            this.$resetPwdErrors.innerHTML = "";
            this.$resetPwdErrors.appendChild($list);
            _.show(this.$resetPwdErrors);
            return;
          }
        }

        this._showResetSuccess();
        this._toSignIn();
      } catch (error) {
        this._hideLoading(this.$resetPwdSubmit, this.$resetPwdLoading);
      }
    }
  }

  _.ready(() => {
    new Auth();
  });
});

/**
 * ======================================
 * ======= Country Selector
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const rawData = JSON.parse(_.$("#CountryCurrencyData").textContent);
  const countries = rawData.countries;

  const countryToCurrencies = {};
  const currencyToCountries = {};

  // 构建两个方向的映射
  countries.forEach((country) => {
    const countryCode = country.code;
    const currencyCode = country.currency.code;

    // country -> currencies
    if (!countryToCurrencies[countryCode]) {
      countryToCurrencies[countryCode] = [];
    }
    if (!countryToCurrencies[countryCode].includes(currencyCode)) {
      countryToCurrencies[countryCode].push(currencyCode);
    }

    // currency -> countries
    if (!currencyToCountries[currencyCode]) {
      currencyToCountries[currencyCode] = [];
    }
    if (!currencyToCountries[currencyCode].includes(countryCode)) {
      currencyToCountries[currencyCode].push(countryCode);
    }
  });

  const selectors = {
    TRIGGER: "[data-trigger='country-selector']",
    DISMISS: "[data-dismiss='country-selector']",
    CONTENT: ".vograce-country-selector .vograce-popup__content",
    CONTROL: ".vograce-country-selector__control",
    SELECT_TRIGGER: "[data-trigger='select']",
    SELECT_TRIGGER_TEXT: ".text-ellipsis",
    SELECT_TRIGGER_FLAG: ".currency-flag",
    SELECT_DISMISS: "[data-dismiss='select']",
    OPTIONS: ".vograce-country-selector__options",
    OPTION: ".vograce-country-selector__option",
    OPTION_SELECTED: ".vograce-country-selector__option.is--selected",
    INPUT: "input[type='hidden']",
  };

  const store = {
    /**
     * Currency Converter Plus Status
     *
     * @type {boolean}
     */
    opened: false,

    /**
     * @type {Map<string, CountrySelectorItem>}
     */
    controllers: new Map(),

    state: {
      COUNTRY: {
        current: 0,
        original: 0,
      },
      LOCALE: {
        current: 0,
        original: 0,
      },
      CURRENCY: {
        current: 0,
        original: 0,
      },
    },

    setState(mod, key, value) {
      this.state[mod][key] = value;
    },

    get(key) {
      return this.controllers.get(key);
    },

    add(key, controller) {
      this.controllers.set(key, controller);
    },

    close() {
      this.closeCurrencyConverterPlus();
      this.controllers.forEach((controller) => {
        controller.close();
      });
    },

    closeCurrencyConverterPlus() {
      if (this.opened) {
        this.opened = false;
        // 兼容关闭 Currency Converter Plus
        _.$$(".currency-converter-chooser").forEach((el) => {
          el.style.display = "none";
        });
      }
    },

    reset() {
      this.controllers.forEach((controller) => {
        controller.reset();
      });
    },
  };

  let updating = false;

  class CountrySelectorItem {
    /**
     * @param {string} key
     * @param {HTMLDivElement} root
     */
    constructor(key, root) {
      this.key = key.toUpperCase();
      this.id = `CountrySelector-${this.key}`;

      /** @type {HTMLDivElement} */
      this.$root = root;

      this._init();
    }

    _init() {
      if (!this.$root) return;

      this.$trigger = /** @type {HTMLButtonElement} */ (
        _.$(selectors.SELECT_TRIGGER, this.$root)
      );
      this.$triggerText = /** @type {HTMLSpanElement} */ (
        _.$(selectors.SELECT_TRIGGER_TEXT, this.$trigger)
      );
      this.$triggerFlag = /** @type {HTMLSpanElement} */ (
        _.$(selectors.SELECT_TRIGGER_FLAG, this.$trigger)
      );
      this.$content = _.getSiblingElement(this.$trigger, selectors.OPTIONS);
      this.$input = _.getSiblingElement(this.$trigger, selectors.INPUT);

      this.type = this.$root.getAttribute("data-type");
      this.currentName = this.$trigger.getAttribute("data-name");
      this.currentValue = this.$trigger.getAttribute("data-value");
      this.originalName = this.currentName;
      this.originalValue = this.currentValue;

      this._buildPopup();
      this._initOptions();
      this._updateSelected();
      this._bindEvents();
    }

    _bindEvents() {
      _.on(this.$trigger, "click", this._open.bind(this));
      _.on(document, "click", this.close.bind(this));
      _.$$(selectors.OPTION, this.$content).forEach((el) => {
        _.on(el, "click", this._select.bind(this));
      });
      _.$$(selectors.SELECT_DISMISS, this.$popup).forEach((el) => {
        _.on(el, "click", this.close.bind(this));
      });
      _.$$(selectors.OPTION, this.$popup).forEach((el) => {
        _.on(el, "click", this._select.bind(this));
      });
    }

    _buildPopup() {
      this.$popup = _.createElement(
        "div",
        {
          id: this.id,
          class: "vograce-popup vograce-country-selector-popup",
          style: {
            zIndex: "11001",
          },
          data: {
            visibility: "hidden",
          },
        },
        `
        <div class="vograce-overlay vograce-popup__overlay" data-dismiss="select"></div>
        <div class="vograce-popup__content">
          <div class="vograce-popup__body" role="dialog">
            <button type="button" class="vograce-close-button" data-dismiss="select" aria-label="close">
              <span role="img" class="vograce-icon vograce-icon--close" aria-label="close">
                <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                  <path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
                </svg>
              </span>
            </button>
            ${this.$content.innerHTML}
          </div>
        </div>
        `
      );
      document.body.appendChild(this.$popup);
    }

    _initOptions() {
      this.$options1 = Array.from(_.$$(selectors.OPTION, this.$content));
      this.$options2 = Array.from(_.$$(selectors.OPTION, this.$popup));
    }

    _open(e) {
      e.stopPropagation();
      if (!this._opened) {
        store.close();
        this._opened = true;
        this._updateSelected();
        const el = _.isMobile() ? this.$popup : this.$content;
        _.show(el);
      } else {
        this.close();
      }
    }

    close(e) {
      if (e) e.stopPropagation();
      if (!this._opened) return;
      this._opened = false;
      const el = _.isMobile() ? this.$popup : this.$content;
      _.hide(el);
    }

    _select(e) {
      e.stopPropagation();
      this.setValue(e.target.closest(selectors.OPTION));
      this.close();
    }

    reset() {
      const options = this.getOptions();
      const option = options[store.state[this.key]["original"]];
      this.setValue(option);
    }

    getOptions() {
      return _.isMobile() ? this.$options2 : this.$options1;
    }

    _getAnotherOptions() {
      return _.isMobile() ? this.$options1 : this.$options2;
    }

    _getSelectedIndex(options) {
      return options.findIndex((o) => o.classList.contains("is--selected"));
    }

    _updateSelected() {
      const options = this.getOptions();
      const anotherOptions = this._getAnotherOptions();
      const i = this._getSelectedIndex(options);
      store.setState(this.key, "current", i);
      store.setState(this.key, "original", i);
      this.$selected = options[i];
      this.$anotherSelected = anotherOptions[i];
    }

    /**
     * @param {HTMLElement} el
     */
    _removeSelectedClass(el) {
      el && _.removeClass(el, "is--selected");
    }

    /**
     * @param {HTMLElement} el
     */
    _addSelectedClass(el) {
      el && _.addClass(el, "is--selected");
    }

    /**
     * @param {HTMLElement} el
     */
    _getData(el, key) {
      return el.getAttribute(`data-${key}`);
    }

    _setAnotherSelected() {
      const anotherOptions = this._getAnotherOptions();
      const i = store.state[this.key]["current"];
      this.$anotherSelected = anotherOptions[i];
    }

    /**
     * 设置当前选中的元素，并更新相关数据和UI
     * @param {HTMLElement} el - 新选中的元素
     */
    setValue(el) {
      this._removeSelectedClass(this.$selected);
      this._removeSelectedClass(this.$anotherSelected);
      // 确保DOM更新后才进行下一步操作
      setTimeout(() => {
        // 更新选中项和其相关数据
        this.$selected = el;
        this._addSelectedClass(this.$selected);

        // 从选中项获取索引、名称和值
        store.setState(this.key, "current", +_.dataset(this.$selected, "index"));
        this.currentName = _.dataset(this.$selected, "name");
        this.currentValue = _.dataset(this.$selected, "value");
        this._setAnotherSelected();
        this._addSelectedClass(this.$anotherSelected);

        // 更新输入框的值和触发器的文本
        if (
          this.$input instanceof HTMLInputElement ||
          this.$input instanceof HTMLTextAreaElement
        ) {
          this.$input.value = this.currentValue;
        }
        this.$triggerText.innerText = this.currentName;

        // 如果类型是国家，更新旗帜图标
        if (this.type === "country") {
          this.$triggerFlag.className = `currency-flag currency-flag--${this.currentValue}`;
          // 如果正在更新，直接返回
          if (updating) return;
          // 根据选中的国家更新货币信息
          this._updateCurrencyByCountry();
          // 更新完成后重置更新状态
          setTimeout(() => {
            updating = false;
          }, 0);
        }

        // 如果类型是货币，更新国家信息
        if (this.type === "currency") {
          // 如果正在更新，直接返回
          if (updating) return;
          // 根据选中的货币更新国家信息
          this._updateCountryByCurrency();
          // 更新完成后重置更新状态
          setTimeout(() => {
            updating = false;
          }, 0);
        }
      }, 0);
    }

    /**
     * 根据国家更新货币
     *
     * 此方法旨在当国家发生变化时，更新与该国家相关的货币选项
     * 它通过随机选择一个与国家关联的货币，并在界面上反映这一变化
     */
    _updateCurrencyByCountry() {
      // 设置更新状态为true，以指示当前正在执行更新操作
      updating = true;

      // 获取货币控制器，以便后续操作货币选项
      const controller = store.get("currency");

      // 根据当前国家获取相关的货币列表，如果找不到，则默认为空数组
      const currentValue = this.currentValue.toUpperCase();
      const currencies = countryToCurrencies[currentValue] || [];

      // 当存在可关联的货币时，执行更新操作
      if (currencies.length > 0) {
        // 随机选择一个货币，以增加一些不可预测性
        const index = Math.floor(Math.random() * currencies.length);
        const currency = currencies[index];

        // 在控制器的选项中找到对应货币的选项
        const option = controller.getOptions().find((el) => el.dataset.value === currency);

        // 设置控制器的值为找到的选项，从而在界面上更新货币
        controller.setValue(option);
      }
    }

    /**
     * 根据货币更新国家
     *
     * 此方法旨在根据当前货币值来更新国家控制器的值
     * 它首先确定是否应根据货币更改国家，然后随机选择一个国家，
     * 最后将国家控制器的值设置为所选国家
     */
    _updateCountryByCurrency() {
      // 设置更新标志以防止重复更新
      updating = true;

      // 获取国家控制器实例
      const controller = store.get("country");

      // 根据当前货币值获取对应的国家列表
      const countries = currencyToCountries[this.currentValue] || [];

      // 如果存在对应的国家列表且不为空
      if (countries.length > 0) {
        // 随机选择一个国家
        const index = Math.floor(Math.random() * countries.length);
        const country = countries[index];

        // 在控制器的选项中找到与所选国家匹配的选项
        const option = controller
          .getOptions()
          .find((el) => el.dataset.value === country.toLowerCase());

        // 将控制器的值设置为所选国家
        controller.setValue(option);
      }
    }
  }

  class CountrySelector {
    constructor() {
      this.$trigger = /** @type {HTMLButtonElement} */ (_.$(selectors.TRIGGER));
      this.$target = /** @type {HTMLDivElement} */ (
        _.$(_.dataset(this.$trigger, "target"))
      );
      this.$content = /** @type {HTMLDivElement} */ (_.$(selectors.CONTENT));

      _.$$(selectors.CONTROL, this.$target).forEach((el) => {
        const key = el.dataset.type;
        if (!key) return;
        // 修正类型错误，将el断言为HTMLDivElement
        const controller = new CountrySelectorItem(
          key,
          /** @type {HTMLDivElement} */ (el)
        );
        store.add(key, controller);
      });

      this._init();
    }

    _init() {
      this._bindEvents();
    }

    _bindEvents() {
      // 打开事件
      _.$$(selectors.TRIGGER).forEach((el) => {
        _.on(el, "click", this._open.bind(this));
      });

      // 关闭事件
      _.$$(selectors.DISMISS).forEach((el) => {
        _.on(el, "click", this._close.bind(this));
      });

      _.on(this.$content, "click", this._closeItem.bind(this));
      _.on(document, "click", this._close.bind(this));
      _.on(window, "resize", this._resize.bind(this));
    }

    /**
     * @param {Event} e
     */
    _open(e) {
      e.stopPropagation();
      /** @type {EventTarget} */
      this.currentTarget = e.currentTarget;
      this._resize();
      this._opened = true;
      _.show(this.$target);
      _.disablePageScroll();
    }

    /**
     * @param {Event} e
     */
    _close(e) {
      e.stopPropagation();
      if (this._opened) {
        this._opened = false;
        _.setAttribute(this.$content, "style", "");
        _.hide(this.$target);
        _.enablePageScroll();
      }
    }

    /**
     * @param {Event} e
     */
    _closeItem(e) {
      e.stopPropagation();
      store.close();
    }

    _resize() {
      if (_.isMobile()) {
        _.setAttribute(this.$content, "style", "");
      } else {
        if (this.currentTarget && this.currentTarget instanceof HTMLElement) {
          const { bottom, right } = _.getRect(this.currentTarget);

          _.css(this.$content, {
            top: `${bottom}px`,
            left: `${right - 400}px`,
            transform: "translate3d(0, 15px, 0)",
          });
        }
      }
    }
  }

  _.ready(() => {
    new CountrySelector();

    let count = 0;
    function loopSetEvent() {
      const __trigger = _.$(".currency-converter-currency-button");
      if (__trigger) {
        // @ts-ignore
        _.on(__trigger, "click", (e) => {
          store.close();
          store.opened = true;
        });

        _.on(document, "click", () => {
          store.closeCurrencyConverterPlus();
        });
      } else {
        if (count < 10) {
          count++;
          setTimeout(loopSetEvent, 2000);
        }
      }
    }

    setTimeout(() => {
      loopSetEvent();
    }, 5000);
  });
});

/**
 * ======================================
 * ======= Search
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    TRIGGER: ".vograce-search[data-trigger='search']",
    INPUT: ".vograce-search__input",
    CLEAR_BUTTON: ".vograce-search__input-button[data-button='clear']",
    SEARCH_BUTTON: ".vograce-search__input-button[data-button='search']",
    POPUP: ".vograce-search__popup",
    POPUP_CONTENT: ".vograce-search__content",
    KEYWORDS_LIST: ".vograce-search__popular-list",
    KEYWORDS_ITEM: ".vograce-search__popular-item",
    PRODUCTS_LIST: ".vograce-search__discover-list",
    PRODUCTS_ITEM: ".vograce-search__discover-item",
  };

  const state = {
    count: 0,
    keywords: "",
  };

  class SearchTrigger {
    /**
     * @constructor
     * @param {HTMLElement} trigger
     */
    constructor(trigger) {
      this.$trigger = trigger;
      this.$input = /** @type {HTMLInputElement} */ (
        _.$(selectors.INPUT, this.$trigger)
      );
      this.$clearBtn = /** @type {HTMLButtonElement} */ (
        _.$(selectors.CLEAR_BUTTON, this.$trigger)
      );
      this.$searchBtn = /** @type {HTMLButtonElement} */ (
        _.$(selectors.SEARCH_BUTTON, this.$trigger)
      );

      /** @type {Record<string, (e?: Event) => void>} */
      this._handlers = {
        onOpen: _.noop,
        onSearch: _.noop,
        onSync: _.noop,
      };
    }

    bindEvents(events) {
      // 绑定外部事件处理器
      this._handlers.onOpen = events.onOpen || _.noop;
      this._handlers.onSearch = events.onSearch || _.noop;
      this._handlers.onSync = events.onSync || _.noop;

      // 绑定内部事件处理器
      _.on(this.$trigger, "click", this._onOpen.bind(this));
      _.on(this.$input, "focus", this._onFocus.bind(this));
      _.on(this.$input, "input", this._onInput.bind(this));
      _.on(this.$input, "keydown", this._onKeyDown.bind(this));
      _.on(this.$clearBtn, "click", this._onClear.bind(this));
      _.on(this.$searchBtn, "click", this._onSearch.bind(this));
    }

    _onOpen(e) {
      e.stopPropagation();
      this._handlers.onOpen(e);
    }

    _onFocus() {
      if (!this.$input.value) return;
    }

    _onInput(e) {
      if (this._sync) return;

      state.keywords = e.target.value;
      state.keywords ? _.show(this.$clearBtn) : _.hide(this.$clearBtn);
      this._handlers.onSync();
    }

    _onKeyDown(e) {
      if (e.key !== "Enter") return;

      this.$searchBtn.click();
    }

    _onClear() {
      state.keywords = "";
      _.hide(this.$clearBtn);
      this._handlers.onSync();
    }

    syncInput() {
      if (state.keywords !== this.$input.value) {
        this._sync = true;
        this.$input.value = state.keywords;
        this._sync = false;
      }
    }

    _onSearch() {
      if (!state.keywords) return;

      this._handlers.onSearch();
    }
  }

  class Search {
    /**
     * @type {SearchTrigger[]}
     */
    _triggers = [];

    constructor() {
      /** @type {HTMLElement} */
      this.$popup = _.$(selectors.POPUP);
      /** @type {HTMLElement} */
      this.$content = _.$(selectors.POPUP_CONTENT, this.$popup);

      this._debouncedOnSearch = _.debounce(this._onSearch.bind(this), 300);

      _.$$(selectors.TRIGGER).forEach((trigger) => {
        this._triggers.push(new SearchTrigger(trigger));
      });

      this._fetchKeywordsAndProducts().then(() => {
        this._bindEvents();

        if (_.isMobile()) {
          this._createCloseButton();
        }
      });
    }

    async _fetchKeywordsAndProducts() {
      try {
        const response = await _.fetch.getJSON("/shopify-api/getTopKeywords");
        const { data } = await response.json();

        const keywords = this._transformKeywords(data.keywords);
        const products = this._transformProducts(data.products);

        const $keywords = _.$(selectors.KEYWORDS_LIST, this.$content);
        const $products = _.$(selectors.PRODUCTS_LIST, this.$content);

        $keywords.innerHTML = this._buildKeywords(keywords);
        $products.innerHTML = this._buildProducts(products);

        _.show(this.$content);
        this._cache = this.$content.innerHTML;
      } catch (error) {
        _.logger.error(error);
      }
    }

    _transformKeywords(keywords) {
      return keywords.map((keyword) => keyword.keyword);
    }

    _transformProducts(products) {
      return products.map((product) => ({
        name: product.title,
        imageUrl: product.url,
        url: product.onlineStoreUrl || product.onlineStorePreviewUrl,
        price: product.price,
      }));
    }

    _buildKeywords(keywords) {
      return keywords
        .map((keyword) => {
          return `<li class="vograce-search__popular-item">${keyword}</li>`;
        })
        .join("");
    }

    _buildProducts(products) {
      return products
        .map((product) => {
          return `
            <li class="vograce-search__discover-item" data-url="${product.url}">
              <img class="vograce-search__discover-img" src="${product.imageUrl}" alt="${product.name}">
              <div class="vograce-search__discover-meta">
                <p class="vograce-search__discover-name">${product.name}</p>
                <p class="vograce-search__discover-price">$${product.price}</p>
              </div>
            </li>
          `;
        })
        .join("");
    }

    _sendKeyword() {
      _.fetch.postJSON("/shopify-api/collectSearchKeywords", {
        keyword: state.keywords,
      });
    }

    async _onSearch() {
      if (!state.keywords) return;

      state.count++;

      const value = state.keywords;
      const params = new URLSearchParams();
      params.append("q", value);
      params.append("resources[limit]", "3");
      params.append("resources[limit_scope]", "each");
      params.append("resources[options][unavailable_products]", "last");
      params.append("section_id", "search-results");

      _.showLoading({ target: this.$content });

      try {
        const response = await _.fetch.get(
          `/search/suggest?${params.toString()}`,
          {
            baseUrl: window.location.origin,
          }
        );

        await _.wait(1000);

        if (!response.ok) {
          throw new Error(response.status.toString());
        }

        const html = await _.fetch.html(response);
        const element = _.$("#shopify-section-search-results", html);

        this._showResult(element);
      } catch (error) {
        this._hideResult();

        throw error;
      }
    }

    _bindEvents() {
      _.on(document, "click", this._onClosePopup.bind(this));
      _.on(this.$popup, "click", this._onClickPopup.bind(this));

      this._triggers.forEach((trigger) => {
        trigger.bindEvents({
          onOpen: this._onOpenPopup.bind(this),
          onSearch: this._navigateToSearchPage.bind(this),
          onSync: this._onSync.bind(this),
        });
      });
    }

    _onSync() {
      if (!state.keywords) {
        this._hideResult();
      }

      this._debouncedOnSearch();
      this._triggers.forEach((trigger) => {
        trigger.syncInput();
      });
    }

    _onClickPopup(e) {
      e.stopPropagation();

      if (e.target.closest(".results__search-btn")) {
        this._navigateToSearchPage();
        return;
      }

      const keyword = e.target.closest(selectors.KEYWORDS_ITEM);
      if (keyword) {
        state.keywords = keyword.textContent;
        this._onSync();
        this._debouncedOnSearch();
        return;
      }

      const product = e.target.closest(selectors.PRODUCTS_ITEM);
      if (product) {
        window.location.href = _.dataset(product, "url");
      }
    }

    _createCloseButton() {
      const $header = _.$(".header-sticky-wrapper");
      const $logoWrapper = _.$(".header-toolbar-logo", $header);

      this.$logo = _.$(".site-header__logo", $logoWrapper);
      _.show(this.$logo);

      this.$closeBtn = _.createElement("button", {
        class: "vograce-search__close-button",
        data: {
          visibility: "hidden",
        },
      });

      this.$closeBtn.innerHTML = [_.Icon("close"), "<span>Vograce</span>"].join('');

      $logoWrapper.appendChild(this.$closeBtn);

      _.on($header, "click", (e) => {
        // 修复：e.target 可能不是 Element 类型，需进行类型断言
        const target = /** @type {Element} */ (e.target);
        if (
          target &&
          typeof target.closest === "function" &&
          target.closest(".vograce-search__close-button") &&
          this._opened
        ) {
          this._hideCloseButtonOnMobile(e);
        }
      });
    }
    z;

    _showCloseButtonOnMobile() {
      _.hide(this.$logo);
      _.show(this.$closeBtn);
    }

    _hideCloseButtonOnMobile(e) {
      e.stopPropagation();
      _.show(this.$logo);
      _.hide(this.$closeBtn);
      _.enablePageScroll();
      this._closePopup();
    }

    _onOpenPopup(e) {
      if (this._opened) return;

      if (_.isMobile()) {
        _.disablePageScroll();
        this._setPopupPositionOnMobile();
        this._showCloseButtonOnMobile();
      } else {
        this._setPopupPosition(e);
      }

      this._openPopup();
    }

    _onClosePopup() {
      if (!this._opened) return;

      this._closePopup();
    }

    _setPopupPositionOnMobile() {
      const element = _.$("#SiteHeader");
      const { height, top } = _.getRect(element);

      _.css(this.$popup, {
        position: 'fixed',
        top: `${height + top}px`,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 11001
      });
    }

    _setPopupPosition(e) {
      const target = e.currentTarget;
      const { bottom, left } = _.getRect(target);

      _.css(this.$popup, {
        position: 'absolute',
        top: `${bottom + 20}px`,
        left: `${left}px`,
      });
    }

    _openPopup() {
      this._opened = true;
      _.show(this.$popup);
    }

    _closePopup() {
      this._opened = false;
      _.hide(this.$popup);
    }

    _navigateToSearchPage() {
      this._sendKeyword();
      window.location.href = `/search?q=${state.keywords}&options[prefix]=last`;
    }

    _showResult(element) {
      if (state.count > 1 || state.count === 0 || !state.keywords) {
        if (state.count > 1) {
          state.count--;
        }
        return;
      }

      this.$content.innerHTML = element.innerHTML;
      state.count = 0;
    }

    _hideResult() {
      this.$content.innerHTML = this._cache;
      state.count = 0;
    }
  }

  _.ready(() => {
    new Search();
  });
});

/**
 * ======================================
 * ======= Tabs
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    ROOT: ".vograce-tabs",
    LIST: ".vograce-tabs__list",
    ITEM: ".vograce-tabs__item",
    CONTENT: ".vograce-tabs__content",
    PANE: ".vograce-tabs__pane",
    MORE: ".vograce-tabs__more",
  };

  const classes = {
    ACTIVE: "is--active",
  };

  class Tabs {
    /**
     * @constructor
     * @param {HTMLElement} root
     */
    constructor(root) {
      /** @type {HTMLElement} */
      this.$root = root;

      this._init();
    }

    _init() {
      if (!this.$root) return;

      this.$list = /** @type {HTMLElement} */ (_.$(selectors.LIST, this.$root));
      this.$more = /** @type {HTMLAnchorElement} */ (
        _.$(selectors.MORE, this.$root)
      );

      // 由于 _select 是类 Tabs 的方法，需要通过 this 绑定
      _.on(this.$list, "click", (e) => this._select(e));
    }

    /**
     * @param {Event} e
     */
    _select(e) {
      e.stopPropagation();
      // 由于 e.target 可能不是 Element 类型，需要进行类型断言
      const target = /** @type {Element} */ (e.target);
      const item = target.closest(selectors.ITEM);
      if (!item) return;

      // 移除所有选中状态
      _.$$(selectors.ITEM, this.$list).forEach((item) => {
        _.removeClass(item, classes.ACTIVE);
      });

      // 添加选中状态
      _.addClass(/** @type {HTMLElement} */ (item), classes.ACTIVE);

      this.$more.href = _.dataset(/** @type {HTMLElement} */ (item), "href");

      // 获取对应的内容区域
      const contentId = _.dataset(
        /** @type {HTMLElement} */ (target),
        "target"
      );
      const $content = /** @type {HTMLElement} */ (
        _.$(selectors.CONTENT, this.$root)
      );
      if ($content) {
        // 隐藏所有内容
        _.$$(selectors.PANE, $content).forEach((pane) => {
          _.hide(/** @type {HTMLElement} */ (pane));
        });
        // 显示当前选中的内容
        const $activePane = /** @type {HTMLElement} */ (
          _.$(`#${contentId}`, $content)
        );
        if ($activePane) {
          _.show(/** @type {HTMLElement} */ ($activePane));
        }
      }
    }
  }

  _.ready(() => {
    _.$$(selectors.ROOT).forEach((root) => {
      new Tabs(root);
    });
  });
});

/**
 * ======================================
 * ======= Brand Equity
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    WRAPPER: ".vograce-brand-equity__wrapper",
    CONTAINER: ".vograce-container",
    ROOT: ".vograce-brand-equity--desktop",
    TOP: ".vograce-brand-equity__top",
    INNER: ".vograce-brand-equity__top-inner",
  };

  class BrandEquity {
    constructor() {
      const root = _.$(selectors.ROOT);
      if (!root) return;
      if (_.dataset(root, "vograceBrandEquityEnable") === "false") return;
      this._init(root);
    }

    _init(root) {
      /** @type {HTMLElement} */
      this.$inner = _.$(selectors.INNER);

      this._maxWidth = document.documentElement.clientWidth;
      this._maxHeight = window.innerHeight;

      const wrapper = _.$(selectors.WRAPPER);
      const container = _.$(selectors.CONTAINER, wrapper);
      const top = _.$(selectors.TOP, root);

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      const wrapperRect = _.getRect(wrapper);
      const containerRect = _.getRect(container);
      const topRect = _.getRect(top);

      this._minWidth = topRect.width;
      this._minHeight = topRect.height;

      const wrapperTop = wrapperRect.top + scrollTop;
      const containerTop = containerRect.top + scrollTop;
      const topTop = topRect.top + scrollTop;

      this._thresholdTop = wrapperTop * 1; // 阈值顶部位置
      this._thresholdBottom = containerTop - 200; // 阈值底部位置
      this._scrollHeight = this._thresholdBottom - this._thresholdTop;
      this._top = wrapperTop - topTop;

      this.$inner.style.top = `${this._top}px`;
      this.$inner.style.width = `${this._maxWidth}px`;
      this.$inner.style.height = `${this._maxHeight}px`;

      // 分别计算最小宽度和最大宽度以及最小高度和最大高度的差值
      this._widthDiff = this._maxWidth - this._minWidth;
      this._heightDiff = this._maxHeight - this._minHeight;

      // 计算阈值底部到顶部的距离
      this._thresholdDistance = this._thresholdBottom - this._thresholdTop;

      this._observe();
    }

    _observe() {
      // 使用 requestAnimationFrame 实现更精确的节流
      let frameId = null;
      const handleScrollRAF = () => {
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(this._handleScroll.bind(this));
      };

      // 使用箭头函数保存 this 上下文
      this._throttledScroll = handleScrollRAF;

      _.on(window, "resize", this._throttledScroll);
      _.on(window, "scroll", this._throttledScroll);
    }

    // 优化后的滚动处理函数
    _handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      let styleConfig;

      // 检查是否在阈值范围内
      if (scrollTop > this._thresholdTop && scrollTop < this._thresholdBottom) {
        // 计算滚动比例，保持在 0-1 范围内
        let ratio = (scrollTop - this._thresholdTop) / this._thresholdDistance;
        ratio = Math.min(1, Math.max(0, ratio));

        // 使用线性插值计算样式值
        styleConfig = {
          top: this._interpolate(this._top, 0, ratio),
          width: this._interpolate(this._maxWidth, this._minWidth, ratio),
          height: this._interpolate(this._maxHeight, this._minHeight, ratio),
          borderRadius: "",
        };
      }
      // 滚动位置在阈值之上
      else if (scrollTop <= this._thresholdTop) {
        styleConfig = {
          top: this._top,
          width: this._maxWidth,
          height: this._maxHeight,
          borderRadius: "",
        };
      }
      // 滚动位置在阈值之下
      else {
        styleConfig = {
          top: 0,
          width: this._minWidth,
          height: this._minHeight,
          borderRadius: "var(--vograce-spacing-md)",
        };
      }

      // 应用样式
      this._applyStyle(styleConfig);
    }

    // 辅助方法：线性插值计算
    _interpolate(start, end, ratio) {
      return start + (end - start) * ratio;
    }

    // 辅助方法：应用样式
    _applyStyle(config) {
      this.$inner.style.cssText = `
        top: ${config.top}px;
        width: ${config.width}px;
        height: ${config.height}px;
        border-radius: ${config.borderRadius};
      `;
    }
  }

  _.ready(() => {
    if (_.isMobile()) return;
    new BrandEquity();
  });
});

/**
 * ======================================
 * ======= Membership
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    WRAPPER: ".vograce-membership",
    POINTS_BALANCE: ".vograce-membership__points-balance",
  };

  const classes = {
    REGULAR_MEMBER: "",
    SILBER_MEMBER: "vograce-membership--silver",
    GOLD_MEMBER: "vograce-membership--gold",
    BLACK_MEMBER: "vograce-membership--platinum",
  };

  _.ready(() => {
    if (!window.customer_id) return;

    const $wrapper = _.$(selectors.WRAPPER);
    if (!$wrapper) return;

    _.fetch
      .getJSON("/shopify-api/account/currentAccountInfo", {
        headers: {
          "customer-id": window.customer_id,
          sign: window.customer_slat,
          timestamp: window.now_timestamp,
        },
      })
      .then((response) => response.json())
      .then(({ data: responseData }) => {
        if (Object.keys(responseData).length === 0) {
          return;
        }

        const $pointsBalance = _.$(selectors.POINTS_BALANCE, $wrapper);

        const currentMembershipLevel =
          responseData.customer_level.toUpperCase();
        const currentMembershipLevelClass = classes[currentMembershipLevel];

        _.addClass($wrapper, currentMembershipLevelClass);
        $pointsBalance.innerHTML = responseData.points;
      });
  });
});

/**
 * ======================================
 * ======= Carousel
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    CAROUSEL: "[data-vograce-carousel]",
    ITEM: "[data-vograce-carousel-item]",
  };

  class Carousel {
    constructor(root) {
      /** @type {HTMLElement} */
      this.$carousel = root;
      /** @type {HTMLElement[]} */
      this._items = Array.from(_.$$(selectors.ITEM, this.$carousel));
      this._current = 0;
      this._distance = 0;
      this._interval = 2000;
      this._isTransitioning = false;
      this._rafId = null;
      this._lastTime = 0;
      this._itemWidths = [];
      this._cloneCount = 0;

      // 克隆一组元素
      this._cloneItems();
      this._init();
    }

    _cloneItems() {
      if (this._items.length < 1) return;

      // 确定克隆数量，至少克隆一组完整的元素
      this._cloneCount = this._items.length;

      // 克隆所有元素并添加到末尾
      for (let i = 0; i < this._cloneCount; i++) {
        const item = /** @type {HTMLElement} */ (
          this._items[i].cloneNode(true)
        );
        item.setAttribute("data-cloned", "true");
        this.$carousel.appendChild(item);
      }

      // 克隆所有元素并添加到开头
      for (let i = this._items.length - 1; i >= 0; i--) {
        const item = /** @type {HTMLElement} */ (
          this._items[i].cloneNode(true)
        );
        item.setAttribute("data-cloned", "true");
        this.$carousel.insertBefore(item, this._items[0]);
      }

      // 更新items数组
      this._items = /** @type {HTMLElement[]} */ (
        Array.from(this.$carousel.children)
      );
    }

    _init() {
      if (this._items.length <= this._cloneCount * 2) return;

      // 计算并缓存每个元素的宽度
      this._calculateItemWidths();

      // 初始位置设置为第一个真实元素（跳过克隆的首个元素组）
      this._current = this._cloneCount;
      this._distance = this._calculateDistanceToIndex(this._current);
      this.$carousel.style.transform = `translateX(-${this._distance}px)`;

      // 禁用过渡效果以避免初始化时的动画
      this.$carousel.style.transition = "none";

      this._lastTime = performance.now();
      this._animate(performance.now());

      // 监听窗口变化，重新计算布局
      _.on(window, "resize", this._handleResize.bind(this));
    }

    _calculateItemWidths() {
      this._itemWidths = [];
      this._items.forEach((item) => {
        // 获取元素宽度，包括margin
        const { marginLeft, marginRight } = window.getComputedStyle(
          /** @type {HTMLElement} */ (item)
        );
        const width = item.offsetWidth;
        const margin = parseFloat(marginLeft) + parseFloat(marginRight);
        this._itemWidths.push(width + margin);
      });
    }

    _handleResize() {
      // 重新计算元素宽度
      this._calculateItemWidths();
      this._distance = this._calculateDistanceToIndex(this._current);
      this.$carousel.style.transform = `translateX(-${this._distance}px)`;
    }

    _calculateDistanceToIndex(index) {
      let distance = 0;
      for (let i = 0; i < index; i++) {
        distance += this._itemWidths[i] || 0;
      }
      return distance;
    }

    _scrollToIndex(index) {
      if (this._isTransitioning) return;

      this._isTransitioning = true;
      this._current = index;
      this._distance = this._calculateDistanceToIndex(index);

      // 启用过渡效果
      this.$carousel.style.transition = "transform 1.2s ease-in-out";
      this.$carousel.style.transform = `translateX(-${this._distance}px)`;

      // 监听过渡结束事件
      const onTransitionEnd = () => {
        this.$carousel.removeEventListener("transitionend", onTransitionEnd);

        // 检查是否需要重置位置（滚动到克隆元素时）
        if (this._current < this._cloneCount) {
          // 瞬间跳转到对应的最后一个真实元素组
          this._current = this._current + this._items.length - this._cloneCount * 2;
          this._distance = this._calculateDistanceToIndex(this._current);
          this.$carousel.style.transition = "none";
          this.$carousel.style.transform = `translateX(-${this._distance}px)`;
        } else if (this._current >= this._items.length - this._cloneCount) {
          // 瞬间跳转到对应的第一个真实元素组
          this._current = this._current - (this._items.length - this._cloneCount * 2);
          this._distance = this._calculateDistanceToIndex(this._current);
          this.$carousel.style.transition = "none";
          this.$carousel.style.transform = `translateX(-${this._distance}px)`;
        }

        // 重置过渡状态
        this._isTransitioning = false;

        // 继续动画循环
        this._animate(performance.now());
      };

      this.$carousel.addEventListener("transitionend", onTransitionEnd);
    }

    _next() {
      const nextIndex = this._current + 1;
      this._scrollToIndex(nextIndex);
    }

    _animate(now) {
      if (this._isTransitioning) return;

      const delta = now - this._lastTime;

      if (delta >= this._interval) {
        this._lastTime = now;
        this._next();
      } else {
        this._rafId = window.requestAnimationFrame(this._animate.bind(this));
      }
    }

    _destroy() {
      if (this._rafId) {
        window.cancelAnimationFrame(this._rafId);
      }
    }
  }

  _.ready(() => {
    _.$$(selectors.CAROUSEL).forEach((el) => {
      new Carousel(el);
    });
  });
});

/**
 * ======================================
 * ======= Accordion
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  class Accordion {
    static selectors = {
      ROOT: "[data-accordion='root']",
      TRIGGER: "[data-trigger='accordion']",
      ACTIVE_ITEM: ".vograce-events__item.is-active",
      ACTIVE_EXTRA: ".vograce-events__image-wrapper.is-active",
    };

    static classes = {
      ACTIVE: "is-active",
    };

    static dataset = {
      TARGET: "target",
    };

    /**
     * @constructor
     * @param {HTMLElement} root
     */
    constructor(root) {
      /**
       * @type {HTMLElement}
       */
      this.$root = root;
      this._init();
    }

    _init() {
      if (!this.$root) return;

      /**
       * @type {HTMLElement}
       */
      this.$activeItem = _.$(Accordion.selectors.ACTIVE_ITEM, this.$root);
      this.$activeExtra = _.$(Accordion.selectors.ACTIVE_EXTRA);
      _.on(this.$root, "click", this._toggle.bind(this));
    }

    /**
     * @param {MouseEvent} e
     */
    _toggle(e) {
      e.stopPropagation();

      const trigger = /** @type {HTMLElement} */ (e.target).closest(
        Accordion.selectors.TRIGGER
      );
      const target = _.dataset(
        /** @type {HTMLElement} */ (trigger),
        Accordion.dataset.TARGET
      );
      const targetElement = _.$(target);

      _.removeClass(this.$activeItem, Accordion.classes.ACTIVE);
      _.removeClass(this.$activeExtra, Accordion.classes.ACTIVE);

      _.addClass(
        /** @type {HTMLElement} */ (trigger),
        Accordion.classes.ACTIVE
      );
      _.addClass(
        /** @type {HTMLElement} */ (targetElement),
        Accordion.classes.ACTIVE
      );

      this.$activeItem = /** @type {HTMLElement} */ (trigger);
      this.$activeExtra = /** @type {HTMLElement} */ (targetElement);
    }
  }

  _.ready(() => {
    _.$$(Accordion.selectors.ROOT).forEach((root) => {
      new Accordion(root);
    });
  });
});

/**
 * ======================================
 * ======= Look
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    ROOT: ".vograce-look",
    HOTSPOTS: ".vograce-look__hotspots",
    HOTSPOT: ".vograce-look__hotspot",
  };

  class Look {
    /**
     * @constructor
     * @param {HTMLElement} root
     */
    constructor(root) {
      /** @type {HTMLElement} */
      this.$root = root;

      this._init();
    }

    _init() {
      if (!this.$root) return;

      /** @type {HTMLElement} */
      this.$hotspots = _.$(selectors.HOTSPOTS, this.$root);

      _.on(this.$hotspots, "click", this._onScrollIntoView.bind(this));
    }

    _onScrollIntoView(e) {
      const hotspot = e.target.closest(selectors.HOTSPOT);

      if (hotspot) {
        const target = hotspot.dataset.target;
        const element = _.$(target);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }
  }

  _.ready(() => {
    _.$$(selectors.ROOT).forEach((root) => {
      new Look(root);
    });
  });
});

/**
 * ======================================
 * ======= Drawer
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    TRIGGER: "[data-trigger='drawer']",
    DISMISS: "[data-dismiss='drawer']",
    OVERLAY: ".vograce-drawer__overlay",
    CONTENT: ".vograce-drawer__content",
    OPEN: "vograce-drawer--open",
  };

  class Drawer {
    /**
     * @constructor
     * @param {HTMLElement} trigger
     */
    constructor(trigger) {
      /** @type {HTMLElement} */
      this.$trigger = trigger;

      this._init();
    }

    /**
     * 初始化
     *
     * @private
     */
    _init() {
      // 选取抽屉目标元素
      this._target = this.$trigger.getAttribute("data-target");
      const element = _.$(this._target);

      // 检查目标元素是否存在
      if (!element)
        return _.logger.error(`Can not find element: ${this._target}`);

      /** 绑定目标元素 @type {HTMLElement} */
      this.$target = element;
      /** 绑定关闭元素 @type {HTMLElement} */
      this.$dismiss = _.$(selectors.DISMISS, element);
      /** 绑定遮罩元素 @type {HTMLElement} */
      this.$overlay = _.$(selectors.OVERLAY, element);
      /** 绑定内容元素 @type {HTMLElement} */
      this.$content = _.$(selectors.CONTENT, element);

      // 初始化打开状态
      this._opened = element.getAttribute("data-visibility") === "visible";

      // 绑定事件
      _.on(this.$trigger, "click", this._handleInternalOpenDrawer.bind(this));
      _.on(this.$dismiss, "click", this._closeDrawer.bind(this));
      _.on(this.$overlay, "click", this._closeDrawer.bind(this));
      _.eventBus.on("vograce:drawer:open", this._handleOpenDrawer.bind(this));
    }

    /**
     * 处理打开抽屉事件
     *
     * @param {string} target 目标元素选择器
     */
    _handleOpenDrawer(target) {
      if (target !== this._target) return;
      this._openDrawer();
    }

    /**
     * 处理内部打开抽屉事件
     *
     * @private
     * @param {Event} e 事件对象
     */
    _handleInternalOpenDrawer(e) {
      e.preventDefault();
      e.stopPropagation();
      this._openDrawer();
    }

    /**
     * 打开抽屉
     *
     * @private
     */
    async _openDrawer() {
      if (!this._opened) {
        this._opened = true;
        _.show(this.$target);
        _.disablePageScroll();
        await _.wait(300);
        _.addClass(this.$target, selectors.OPEN);
      }
    }

    /**
     * 关闭抽屉
     *
     * @private
     * @param {Event} e
     */
    async _closeDrawer(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this._opened) {
        this._opened = false;
        _.removeClass(this.$target, selectors.OPEN);
        await _.wait(300);
        _.hide(this.$target);
        _.enablePageScroll();
      }
    }
  }

  _.ready(() => {
    _.$$(selectors.TRIGGER).forEach((trigger) => {
      new Drawer(trigger);
    });
  });
});

/**
 * ======================================
 * ======= SignIn & SignUp
 * ======================================
 */
window.__VOGRACE__.sandbox((_) => {
  const selectors = {
    SIGN_IN: "[data-trigger='sign-in']",
    SIGN_UP: "[data-trigger='sign-up']",
  };

  const handleAuthClick = (e) => {
    const signIn = e.target.closest(selectors.SIGN_IN);
    if (signIn) {
      _.showLoginPopup();
      return;
    }

    const signUp = e.target.closest(selectors.SIGN_UP);
    if (signUp) {
      _.showRegisterPopup();
      return;
    }
  };

  _.ready(() => {
    _.on(document, "click", handleAuthClick);
  });
});

/**
 * ======================================
 * ======= Shipping and Production Estimate
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  const selectors = {
    ROOT: ".vograce-cart__estimate",
    CART_ITEM: "[data-cart-item='root']",
    REGION_CHOOSER: ".vograce-cart__estimate-region-chooser",
    CONTROL: ".vograce-cart__estimate-control",
    CONTROL_PLACEHOLDER: ".vograce-cart__estimate-placeholder",
    CONTROL_ARROW: ".vograce-cart__estimate-arrow",
    DROPDOWN: ".vograce-cart__estimate-dropdown",
    SEARCH: ".vograce-cart__estimate-search input",
    OPTIONS: ".vograce-cart__estimate-options",
    RESULTS: ".vograce-cart__estimate-results",
    TIPS: ".vograce-cart__estimate-tips"
  };

  const classes = {
    OPENED: "is--opened",
    SELECTED: "is--selected",
  };

  function getBaseUrlByShopifyDomain() {
    const shopifyDomain = window.Shopify.shop;

    switch (shopifyDomain) {
      case "xn-ooru7ap8r6la930dn7x8fucnc.myshopify.com":
        return "https://test2-erp.baigedi.com";

      case "vograce-myshopify.com":
      default:
        return "https://erp.baigedi.com";
    }
  }

  const urls = {
    ALL_COUNTRIES: "/api/info/getAllCountrys",
    RESULTS: "/api/info/countCartShippingPrice",
  };

  class ShippingAndProductionEstimate {
    constructor() {
      this.$root = _.$(selectors.ROOT);
      this._init();
    }

    async _init() {
      if (!this.$root) return;

      // 绑定元素
      this.$control = _.$(selectors.CONTROL, this.$root);
      this.$placeholder = _.$(selectors.CONTROL_PLACEHOLDER, this.$root);
      this.$arrow = _.$(selectors.CONTROL_ARROW, this.$root);
      this.$dropdown = _.$(selectors.DROPDOWN, this.$root);
      this.$search = _.$(selectors.SEARCH, this.$root);
      this.$options = _.$(selectors.OPTIONS, this.$root);
      this.$results = _.$(selectors.RESULTS, this.$root);
      this.$tips = _.$(selectors.TIPS, this.$root);

      const hide = _.showLoading({ target: this.$results });

      await this._fetchCountries();
      await this._fetchResults();
      await _.wait(500);

      hide();

      // 渲染内容
      this._renderOptions();
      this._renderResults();

      // 初始化状态
      this._id = 0;
      this._placeholder = _.dataset(this.$placeholder, "placeholder");
      this._opened = _.hasClass(this.$control, classes.OPENED);

      this._handleSearch = _.debounce(this._search.bind(this), 100);

      // 绑定事件
      _.on(this.$control, "click", this._toggleDropdown.bind(this));
      _.on(this.$search, "input", this._handleSearch);
      _.on(this.$search, "click", (e) => e.stopPropagation());
      _.on(this.$options, "click", this._selectOption.bind(this));
      _.on(document, "click", this._closeDropdown.bind(this));

      // 监听 eventBus 事件
      _.eventBus.on(
        "vograce:shipping-and-production-estimate:refresh",
        this._refreshResults.bind(this)
      );
    }

    async _fetchCountries() {
      try {
        const payload = { page: 1, limit: 99999 };
        const response = await _.fetch.postJSON(urls.ALL_COUNTRIES, payload, {
          baseUrl: getBaseUrlByShopifyDomain(),
        });
        const result = await response.clone().json();

        /**
         * @typedef Country
         * @property {number} id
         * @property {string} code
         * @property {string} en
         * @property {string} cn
         */

        /**
         * @type {Country[]}
         */
        this._countries = result.data.data;
        this._originalCountries = this._countries;
      } catch (error) {
        _.logger.error(error);
      }
    }

    async _fetchResults() {
      try {
        const formData = new URLSearchParams();

        Array.from(_.$$(selectors.CART_ITEM)).forEach((item, i) => {
          const productId = _.dataset(item, "cartItemProductId");
          const variantId = _.dataset(item, "cartItemVariantId");
          const quantity = _.dataset(item, "cartItemQuantity");
          const graphqlVariantId = _.dataset(item, "cartItemGraphqlVariantId");
          const originalPrice = _.dataset(item, "cartItemOriginalPrice");
          const finalPrice = _.dataset(item, "cartItemFinalPrice");

          formData.append(`products[${i}][third_product_id]`, productId);
          formData.append(`products[${i}][variant_id]`, variantId);
          formData.append(`products[${i}][quantity]`, quantity);
          formData.append(`products[${i}][admin_graphql_api_id]`, graphqlVariantId);
          formData.append(`products[${i}][original_price]`, originalPrice);
          formData.append(`products[${i}][final_price]`, finalPrice);
        });

        formData.append("customer_id", window.customer_id || "");
        formData.append("country_id", this._id || 2);

        const payload = formData.toString();
        const response = await _.fetch.postJSON(urls.RESULTS, payload, {
          baseUrl: getBaseUrlByShopifyDomain(),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        const result = await response.clone().json();

        if (!_.isArray(result.data)) {
          this._id = result.data.country_id;
          this._results = result.data.html;
        }

        this._updateSelected();
      } catch (error) {
        _.logger.error(error);
      }
    }

    _renderOptions() {
      let html = "";
      this._countries.forEach((country) => {
        html += `<li data-id="${country.id}" data-code="${country.code}">${country.en}</li>`;
      });
      this.$options.innerHTML = html;
    }

    _renderResults() {
      if (!this._results) return;

      // 清除提示区和结果区内容
      this.$tips.innerHTML = "";
      this.$results.innerHTML = "";

      const html = `
        <thead><tr><th>Shipping method</th><th>Estimated delivery fee</th></tr></thead>
        <tbody>${this._results}</tbody>
      `;

      const table = _.createElement("table", {}, html);
      const rowspan = _.$("td[rowspan]", table);
      const innerHTML = rowspan.innerHTML;

      rowspan.remove();

      const p1 = _.createElement("h5", { class: 'vograce-typography' }, 'Estimated Production time');
      const p2 = _.createElement("p", {}, "The time to confirm the proof is not counted in the production time");
      const p3 = _.createElement("p", {}, innerHTML);
      const p4 = _.createElement("p", {}, "Production time (The time to confirm the proof is not counted in the production time. If you order a variety of products, the shipping date is based on the product with the longest production time.)");

      this.$tips.appendChild(p1);
      this.$tips.appendChild(p2);
      this.$tips.appendChild(p3);
      this.$tips.appendChild(p4);
      this.$results.appendChild(table);
    }

    _refreshResults() {
      _.showLoading({ target: this.$root });
      this._fetchResults()
        .then(() => this._renderResults())
        .finally(() => _.hideLoading(this.$root));
    }

    _toggleDropdown(e) {
      e.stopPropagation();

      if (this._opened) {
        this._closeDropdown();
      } else {
        this._openDropdown();
      }
    }

    _openDropdown() {
      this._opened = true;
      _.addClass(this.$control, classes.OPENED);
      _.show(this.$dropdown);
    }

    _closeDropdown() {
      this._opened = false;
      _.removeClass(this.$control, classes.OPENED);
      _.hide(this.$dropdown);
    }

    _search(e) {
      const value = e.target.value;
      if (!value) {
        this._countries = this._originalCountries;
      } else {
        this._countries = this._originalCountries.filter((country) => {
          return country.en.toLowerCase().includes(value);
        });
      }
      this._renderOptions();
    }

    async _selectOption(e) {
      const target = e.target;
      const id = +_.dataset(target, "id");

      if (this._id === id) return;

      const textContent = target.textContent;
      _.showLoading({ target: this.$results });

      this._id = id;
      this.$placeholder.textContent = textContent;

      await this._fetchResults();
      await _.wait(500);
      _.hideLoading(this.$results);
      this._renderResults();
    }

    _updateSelected() {
      const country = this._countries.find((country) => {
        return country.id === this._id;
      });

      if (!country) {
        this.$placeholder.textContent = this._placeholder;
        _.removeClass(this.$control, classes.SELECTED);
        return;
      }

      this.$placeholder.textContent = country.en;
      _.addClass(this.$control, classes.SELECTED);
    }
  }

  _.ready(() => {
    new ShippingAndProductionEstimate();
  });
});

/**
 * ======================================
 * ======= Apply BSS PL Label
 * ======================================
 */
window.__VOGRACE__.sandbox((_) => {
  /**
   * 常量定义：BSS_PL_SHOPIFY_PLUGIN
   *
   * 用于标识 BSS PL Shopify 插件的唯一标识符
   * 该常量作为插件的名称或标识使用
   */
  const BSS_PL_SHOPIFY_PLUGIN = "BSS_PL";

  // _.ready(async () => {
  //   // 仅对首页进行操作
  //   if (!isHomepage()) return;

  //   try {
  //     // 加载 BSS PL Shopify Plugin
  //     const BSS_PL = await waitForShopifyPlugin(BSS_PL_SHOPIFY_PLUGIN);

  //     // 等待 jQuery 挂载到 BSS PL 上
  //     const $ = await waitForJQuery(BSS_PL);

  //     // 等待 5s，用于等待 BSS PL 初始化的结束
  //     await _.wait(5000);

  //     const elementList = $(".grid__item-image-wrapper[data-handle]");
  //     const elements = elementList.toArray();
  //     const handles = elements.map(extractHandle);
  //     const chunks = chunk(handles);

  //     BSS_PL.plWorker.onmessage = (e) => {
  //       if (e.data.type === "error") return;

  //       e.data.data.forEach((product) => {
  //         const handle = product.handle;

  //         const parents = $(`.grid__item-image-wrapper[data-handle="${handle}"]`);
  //         const parent = parents[0];

  //         BSS_PL.initForLabel($, BSS_PL, parents, parent, product, {
  //           baseImgUrl: BSS_PL.apiServerProduction + "/images/" + BSS_PL.storeId + "/240/",
  //           collects: product.collections,
  //         });
  //       });
  //     };

  //     chunks.forEach((chunk) => {
  //       const q = chunk.join(" OR ");
  //       const url = `${window.location.origin}/search?q=${q}&type=product&view=bss.product.labels`;

  //       BSS_PL.plWorker.postMessage({
  //         action: "getProductData",
  //         data: {
  //           urlSearchLiquid: url,
  //           handlesList: chunk,
  //           publicAccessToken: BSS_PL.publicAccessToken,
  //           domain: window.Shopify.shop,
  //           configProductMetafields: BSS_PL.configProductMetafields,
  //           configVariantMetafields: BSS_PL.configVariantMetafields,
  //           isPageFly: false,
  //         },
  //       });
  //     });
  //   } catch (error) {
  //     _.logger.error(error);
  //   }
  // });

  /**
   * 判断当前页面是否是首页
   */
  function isHomepage() {
    return (
      typeof window.template !== "undefined" && window.template === "index"
    );
  }

  /**
   * 等待 Shopify 插件加载完成
   *
   * @param {string} pluginName - 要等待加载的插件名称，该名称应为 window 对象上的属性名
   * @param {number} [timeout=10000] - 等待超时时间（毫秒），默认值为 10000ms（10秒）
   * @returns {Promise<any>} 返回加载完成的插件对象
   * @throws {Error} 当插件在指定超时时间内未加载完成时抛出错误
   */
  async function waitForShopifyPlugin(pluginName, timeout = 10000) {
    const startTime = Date.now();

    // 循环检查插件是否已加载到 window 对象中
    while (!window[pluginName]) {
      // 检查是否已超时
      if (Date.now() - startTime > timeout) {
        throw new Error(`Plugin ${pluginName} failed to load within ${timeout}ms`);
      }

      // 等待 100ms 后再次检查
      await _.wait(100);
    }

    const shopifyPlugin = window[pluginName];

    // 插件加载成功
    _.logger.info(`${pluginName} loaded successfully`, shopifyPlugin);

    // 返回已加载的插件对象
    return shopifyPlugin;
  }

  /**
   * 等待 JQuery 挂载到 BSS PL 上
   *
   * @param {Object} plugin - 插件对象
   * @param {number} [timeout=10000] - 超时时间（毫秒）
   * @returns {Promise<any>} -  JQuery 对象
   * @throws {Error} 当 JQuery 在指定超时时间内未加载完成时抛出错误
   */
  async function waitForJQuery(plugin, timeout = 10000) {
    const startTime = Date.now();

    while (!plugin.$) {
      // 检查是否已超时
      if (Date.now() - startTime > timeout) {
        throw new Error(`JQuery 未在 ${timeout}ms 内加载完成`);
      }

      // 等待 100ms 后再次检查
      await _.wait(100);
    }

    // 返回已挂载的 jQuery 对象
    return plugin.$;
  }

  /**
   * 提取元素的 handle
   *
   * @param {HTMLElement} element - 需要提取 handle 的元素
   * @returns {string} - 元素的 handle
   */
  function extractHandle(element) {
    // 检查元素是否存在 data-handle 属性
    if (element && element.dataset && element.dataset.handle) {
      return `handle:"${element.dataset.handle}"`;
    }

    return null;
  }

  /**
   * 将输入的数组或字符串按固定大小进行分块处理
   *
   * @param {Array|string} source - 需要分块的源数据，可以是数组或字符串
   * @returns {Array} 返回一个包含分块数据的数组，每个元素都是原数据的一个片段
   */
  function chunk(source) {
    const chunks = [];

    // 按照每 30个元素为一组的方式对源数据进行分块
    for (let i = 0; i < source.length; i += 30) {
      chunks.push(source.slice(i, i + 30));
    }

    return chunks;
  }
});

/**
 * ======================================
 * ======= VG
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  /**
   * 滑块
   */
  class VGSlider {
    /**
     * 选择器常量集
     *
     * @static
     */
    static selectors = {
      ROOT: "[data-slider='root']",
      SCROLLER: "[data-slider='scroller']",
      SLIDE: "[data-slider='slide']",
      PREV: "[data-slider-action='prev']",
      NEXT: "[data-slider-action='next']",
      EXTERNAL_PREV: "[data-behavior='slider'][data-behavior-action='prev']",
      EXTERNAL_NEXT: "[data-behavior='slider'][data-behavior-action='next']",
    };

    /**
     * 数据集常量集
     *
     * @static
     */
    static datasets = {
      ROLLING_SLIDES: "sliderRollingSlides",
      ROLLING_DISTANCE: "sliderRollingDistance",
      INFINITE: "sliderInfinite",
      AUTOPLAY: "sliderAutoplay",
      AUTOPLAY_INTERVAL: "sliderAutoplayInterval",
      BEHAVIOR_TARGET: "behaviorTarget",
    };

    /**
     * 默认配置
     *
     * @typedef {Object} VGSliderConfig
     * @property {number} rollingSlides
     * @property {number} rollingDistance
     * @property {boolean} infinite
     *
     * @static
     * @constant
     * @type {VGSliderConfig}
     */
    static DEFAULT_CONFIG = {
      rollingSlides: 1,
      rollingDistance: 0,
      infinite: false,
      autoplay: false,
      autoplayInterval: 5000
    };

    /**
     * @constructor
     * @param {HTMLElement} root
     */
    constructor(root) {
      if (_.isMobile()) return;

      /** @type {HTMLElement} */
      this.$root = root;
      /** @type {HTMLElement} */
      this.$scroller = _.$(VGSlider.selectors.SCROLLER, root);
      /** @type {Array<HTMLElement>} */
      this.$slides = Array.from(_.$$(VGSlider.selectors.SLIDE, root));

      /** @type {VGSliderConfig} */
      this._config = this._getConfig();

      // 项目数量
      this._itemCount = this.$slides.length;
      // 当前索引
      this._currentIndex = 0;
      // 可滚动距离
      this._scrollableDistance = this._calculateScrollableDistance();
      // 已滚动距离
      this._distance = 0;

      this._autoplayTimer = null;

      this._init();
    }

    /**
     * 获取配置
     *
     * @returns {VGSliderConfig}
     */
    _getConfig() {
      const defaults = { ...VGSlider.DEFAULT_CONFIG };

      const rollingSlides = +_.dataset(this.$root, VGSlider.datasets.ROLLING_SLIDES);
      const rollingDistance = +_.dataset(this.$root, VGSlider.datasets.ROLLING_DISTANCE);
      const infinite = _.dataset(this.$root, VGSlider.datasets.INFINITE) !== "false";
      const autoplay = _.dataset(this.$root, VGSlider.datasets.AUTOPLAY) === 'true';
      const autoplayInterval = +_.dataset(this.$root, VGSlider.datasets.AUTOPLAY_INTERVAL) || 5000;

      return Object.assign(defaults, {
        rollingSlides,
        rollingDistance: isNaN(rollingDistance) ? 0 : rollingDistance,
        infinite,
        autoplay,
        autoplayInterval
      });
    }

    /**
     * 启动自动播放
     */
    _startAutoplay() {
      if (!this._config.autoplay || this._autoplayTimer) return;

      this._autoplayTimer = setInterval(() => {
        this.next();
      }, this._config.autoplayInterval);
    }

    /**
     * 停止自动播放
     */
    _stopAutoplay() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    /**
     * 重置自动播放（常用于用户操作后恢复）
     */
    _resetAutoplay() {
      this._stopAutoplay();
      this._startAutoplay();
    }

    /**
     * 计算可滚动距离
     *
     * @returns {number}
     */
    _calculateScrollableDistance() {
      // 如果项目数量为0，则返回0
      if (this._itemCount === 0) return 0;

      // 如果配置了滚动距离，则返回配置的滚动距离
      if (this._config.rollingDistance > 0) return this._config.rollingDistance;

      // 获取第一个项目的宽度
      let { width } = _.getRect(this.$slides[0]);

      // 如果宽度为0，则返回0
      if (width === 0) {
        width = _.isMobile() ? 200 : 342;
      }

      return width + 24; // 24是gap
    }

    /**
     * 初始化
     */
    _init() {
      // 启用无限滚动
      if (this._config.infinite && this._itemCount !== 0) {
        this._enableInfiniteScroll();
      } else {
        // 非无限滚动状态下设置切换按钮状态
        this._toggleButtonDisabledStatus();
      }

      // 绑定事件
      this._bindEvents();

      // 如果启用 autoplay，则启动
      if (this._config.autoplay && this._itemCount > 1) {
        this._startAutoplay();
      }
    }

    /**
     * 启用无限滚动
     */
    _enableInfiniteScroll() {
      const beforeSlides = [];
      const afterSlides = [];

      // 克隆项目
      this.$slides.forEach((slide) => {
        const before = slide.cloneNode(true);
        const after = slide.cloneNode(true);
        _.dataset(/** @type {HTMLElement} */ (before), "cloned", "true");
        _.dataset(/** @type {HTMLElement} */ (after), "cloned", "true");
        beforeSlides.push(before);
        afterSlides.push(after);
      });

      this.$slides = [...beforeSlides, ...this.$slides, ...afterSlides];
      this._distance = this._currentIndex * this._scrollableDistance;

      // 隐藏并清空滚动区域
      this.$scroller.style.visibility = "hidden";
      this.$scroller.innerHTML = "";

      // 添加项目
      this.$scroller.append(...this.$slides);

      // 显示并设置初始位置
      this.$scroller.style.visibility = "visible";
      this.$scroller.style.transform = `translateX(-${this._distance}px)`;
    }

    /**
     * 绑定事件
     */
    _bindEvents() {
      // 添加点击事件处理器
      _.on(this.$root, "click", this._handleClick.bind(this));

      _.on(this.$root, "mouseenter", this._handleMouseEnter.bind(this));
      _.on(this.$root, "mouseleave", this._handleMouseLeave.bind(this));

      if (this._config.infinite && this._itemCount !== 0) {
        // 添加过渡结束事件处理器
        _.on(this.$scroller, "transitionend", this._handleTransitionEnd.bind(this));
      }
    }

    _handleMouseEnter() {
      if (this._config.autoplay) {
        this._stopAutoplay();
      }
    }

    _handleMouseLeave() {
      if (this._config.autoplay) {
        this._startAutoplay();
      }
    }

    /**
     * 处理内部行为
     */
    _handleClick(e) {
      const prevTarget = e.target.closest(VGSlider.selectors.PREV);
      if (prevTarget) {
        this.prev();
        return;
      }

      const nextTarget = e.target.closest(VGSlider.selectors.NEXT);
      if (nextTarget) {
        this.next();
        return;
      }
    }

    /**
     * 切换上一项
     */
    prev() {
      if (!this._config.infinite && this._currentIndex === 0) return;

      this._currentIndex -= this._config.rollingSlides;
      this._distance = this._currentIndex * this._scrollableDistance;

      this._toggleButtonDisabledStatus();
      this._scroll(true);

      if (this._config.autoplay) {
        this._resetAutoplay();
      }
    }

    /**
     * 切换下一项
     */
    next() {
      if (!this._config.infinite && this._currentIndex >= this._itemCount - this._config.rollingSlides) return;

      this._currentIndex += this._config.rollingSlides;
      this._distance = this._currentIndex * this._scrollableDistance;

      this._toggleButtonDisabledStatus();
      this._scroll(true);

      if (this._config.autoplay) {
        this._resetAutoplay();
      }
    }

    /**
     * 切换按钮禁用状态
     */
    _toggleButtonDisabledStatus() {
      if (this._config.infinite) return;

      if (!this.$prev) {
        this.$prev = _.$(VGSlider.selectors.PREV, this.$root);
      }

      if (!this.$next) {
        this.$next = _.$(VGSlider.selectors.NEXT, this.$root);
      }

      if (this._currentIndex === 0) {
        this.$prev.setAttribute("disabled", "disabled");
        this.$next.removeAttribute("disabled");
      } else if (this._currentIndex >= this._itemCount - this._config.rollingSlides) {
        this.$prev.removeAttribute("disabled");
        this.$next.setAttribute("disabled", "disabled");
      } else {
        this.$prev.hasAttribute("disabled") && this.$prev.removeAttribute("disabled");
        this.$next.hasAttribute("disabled") && this.$next.removeAttribute("disabled");
      }
    }

    /**
     * 处理过渡结束
     */
    _handleTransitionEnd() {
      // 如果滚动到了开头的克隆项
      if (this._currentIndex < this._config.rollingSlides) {
        // 瞬间跳转到末尾的真实项
        this._currentIndex = this._currentIndex + this._itemCount;
        this._distance = this._currentIndex * this._scrollableDistance;

        // 瞬间跳转，无过渡效果
        this._scroll(false);
      }
      // 如果滚动到了末尾的克隆项
      else if (
        this._currentIndex >=
        this._itemCount + this._config.rollingSlides
      ) {
        // 瞬间跳转到开头的真实项
        this._currentIndex = this._currentIndex - this._itemCount;
        this._distance = this._currentIndex * this._scrollableDistance;

        // 瞬间跳转，无过渡效果
        this._scroll(false);
      }
    }

    /**
     * 滚动
     *
     * @param {boolean} [withTransition=false] 是否启用过渡效果
     */
    _scroll(withTransition = false) {
      _.css(this.$scroller, {
        transform: `translateX(-${this._distance}px)`,
        transition: withTransition ? "transform 0.3s ease-in-out" : "none",
      });
    }

    /**
     * 初始化
     *
     * @static
     */
    static setup() {
      if (_.isMobile()) return;

      _.$$(VGSlider.selectors.ROOT).forEach((root) => {
        window.__VOGRACE_SLIDER__.set(root.id, new VGSlider(root));
      });

      _.on(document, "click", (e) => {
        const prevTarget = /** @type {HTMLElement} */ (e.target).closest(
          VGSlider.selectors.EXTERNAL_PREV
        );
        if (prevTarget) {
          const id = _.dataset(
            /** @type {HTMLElement} */ (prevTarget),
            VGSlider.datasets.BEHAVIOR_TARGET
          );
          const slider = window.__VOGRACE_SLIDER__.get(id);
          slider && slider.prev();
          return;
        }

        const nextTarget = /** @type {HTMLElement} */ (e.target).closest(
          VGSlider.selectors.EXTERNAL_NEXT
        );
        if (nextTarget) {
          const id = _.dataset(
            /** @type {HTMLElement} */ (nextTarget),
            VGSlider.datasets.BEHAVIOR_TARGET
          );
          const slider = window.__VOGRACE_SLIDER__.get(id);
          slider && slider.next();
          return;
        }
      });
    }
  }

  /**
   * 购物车
   *
   * @typedef {Array<Array<string, string>>} ShopifyCartItemProperties
   *
   * @typedef {Object} ShopifyCartAppliedDiscount
   * @property {string} key
   * @property {string} name
   * @property {number} amount
   *
   * @typedef {Object} ShopifyCartItemDiscount
   * @property {number} m 最小数量
   * @property {number} d 折扣
   *
   * @typedef {Object} ShopifyCartItemOptionWithValue 购物车商品选项值
   * @property {string} name
   * @property {string} value
   *
   * @typedef {Object} ShopifyCartItem 购物车商品
   * @property {number} id
   * @property {string} key
   * @property {string} handle
   * @property {string} image
   * @property {string} url
   * @property {number} variant_id
   * @property {number} product_id
   * @property {string} product_title
   * @property {Array<ShopifyCartItemDiscount>} product_discounts
   * @property {Array<ShopifyCartItemOptionWithValue>} options_with_values
   * @property {ShopifyCartItemProperties} properties
   * @property {number} original_price
   * @property {number} price
   * @property {number} original_line_price
   * @property {number} line_price
   * @property {number} quantity
   *
   * @typedef {Object} VGCartItem 购物车商品
   * @property {number} id
   * @property {string} key
   * @property {string} handle
   * @property {string} imageUrl
   * @property {string} url
   * @property {number} vid
   * @property {number} pid
   * @property {string} title
   * @property {Array<ShopifyCartItemOptionWithValue>} options 选项
   * @property {ShopifyCartItemProperties} properties
   * @property {number} originalPrice
   * @property {number} price
   * @property {number} originalLinePrice
   * @property {number} linePrice
   * @property {number} quantity
   * @property {string} source
   * @property {Array<ShopifyCartItemDiscount>} discounts
   */
  class VGCart {
    /**
     * 选择器
     */
    static selectors = {
      // 购物车
      CART: "[data-cart='root']",
      CART_ITEMS_COUNT: "[data-cart='items-count']",
      CART_ITEMS: "[data-cart='items']",
      CART_MEMBER: "[data-cart='member']",

      // 购物车抽屉
      CART_DRAWER: "[data-cart-drawer='root']",
      CART_DRAWER_ITEMS_COUNT: "[data-cart-drawer='items-count']",
      CART_DRAWER_ITEMS: "[data-cart-drawer='items']",
      CART_DRAWER_MEMBER: "[data-cart-drawer='member']",

      // 购物车结算
      CART_CHECKOUT: "[data-cart-checkout='root']",
      CART_CHECKOUT_DISCOUNT: "[data-cart-checkout='discount']",

      // 购物车商品
      CART_ITEM: "[data-cart-item='root']",
      CART_ITEM_OPTIONS: "[data-cart-item='options']",

      // 会员卡
      CART_MEMBER_TITLE: "[data-cart-member='title']",
      CART_MEMBER_BUTTON: "[data-cart-member='button']",
    };

    static behaviors = {
      SHOW_MORE_OPTIONS: "[data-behavior='show-more-options']",
      SHOW_DELETE_CONFIRM: "[data-behavior='show-delete-confirm']",
      SHOW_DISCOUNTS: "[data-behavior='show-discounts']",
      CHECKOUT: "[data-behavior='checkout']",
      ADD_TO_CART: "[data-behavior='add-to-cart']",
      ADD_MEMBER_CARD_TO_CART: "[data-behavior='add-member-card-to-cart']",
      TOGGLE_DISCOUNT_DETAILS: "[data-behavior='toggle-discount-details']",
    };

    static datasets = {
      CART_EMPTY_TEXT: "cartEmptyText",
      CART_EMPTY_BUTTON_URL: "cartEmptyButtonUrl",
      CART_EMPTY_BUTTON_TEXT: "cartEmptyButtonText",
    };

    /**
     * 事件类型
     */
    static events = {
      ADD: "vograce:cart:add",
      UPDATE: "vograce:cart:update",
      REMOVE: "vograce:cart:remove",
      OPEN_DRAWER: "vograce:cart-drawer:open",
    };

    /**
     * 会员卡
     */
    static memberCards = {
      Gold: {
        title: "Join Gold Member",
        imageUrl:
          "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/Gold_Member.png?v=1759201824",
        url: "products/vograce-gold-member",
      },
      Silver: {
        title: "Join Silver Member",
        imageUrl:
          "https://cdn.shopify.com/s/files/1/0336/9297/5240/files/Silver_Member.png?v=1759201824",
        url: "products/vograce-silver-member",
      },
    };

    /**
     * @constructor
     */
    constructor() {
      /** @type {boolean} */
      this._isCartPage = window.template === "cart";
      /** @type {string} */
      this._classPrefix = this._isCartPage
        ? "vograce-cart"
        : "vograce-cart-drawer";

      if (this._isCartPage) {
        /** @type {HTMLElement} */
        this.$root = _.$(VGCart.selectors.CART);
        /** @type {HTMLElement} */
        this.$itemsCount = _.$(VGCart.selectors.CART_ITEMS_COUNT);
        /** @type {HTMLElement} */
        this.$items = _.$(VGCart.selectors.CART_ITEMS);
        /** @type {HTMLElement} */
        this.$checkout = _.$(VGCart.selectors.CART_CHECKOUT);
        /** @type {HTMLElement} */
        this.$member = _.$(VGCart.selectors.CART_MEMBER);
      } else {
        /** @type {HTMLElement} */
        this.$root = _.$(VGCart.selectors.CART_DRAWER);
        /** @type {HTMLElement} */
        this.$itemsCount = _.$(VGCart.selectors.CART_DRAWER_ITEMS_COUNT);
        /** @type {HTMLElement} */
        this.$items = _.$(VGCart.selectors.CART_DRAWER_ITEMS);
        /** @type {HTMLElement} */
        this.$checkout = _.$(VGCart.selectors.CART_CHECKOUT);
        /** @type {HTMLElement} */
        this.$member = _.$(VGCart.selectors.CART_DRAWER_MEMBER);
      }

      /** @type {Map<string, VGCartItem>} */
      this._itemsMap = new Map();

      /** @type {Set<string>} */
      this._expandedKeys = new Set();

      this._init();
    }

    /**
     * 初始化
     */
    _init() {
      this._initItemsMap();
      this._initEmptyInfo();
      this._initDiscountExpanded();
      this._bindEvents();
      this._fetchMemberCardInfo();
    }

    /**
     * 初始化折扣
     * @returns {void}
     */
    _initDiscountExpanded() {
      /** @type {boolean} */
      this._isDiscountDetailsExpanded = this._isCartPage;
    }

    /**
     * 初始化商品与折扣映射
     */
    _initItemsMap() {
      Array.from(_.$$(VGCart.selectors.CART_ITEM, this.$items)).forEach(
        (item) => {
          const source = _.dataset(item, "cartItemSource");
          const discounts = _.dataset(item, "cartItemDiscount");
          const parsedSource = JSON.parse(source);
          const parsedDiscount = discounts ? JSON.parse(discounts) : {};
          const transformedItem = this._transformSingleCartItem(
            parsedSource,
            parsedDiscount
          );
          this._itemsMap.set(transformedItem.key, transformedItem);
        }
      );

      // 映射购物车商品总量
      this._itemsCount = this._itemsMap.size;
    }

    /**
     * 初始化空信息
     */
    _initEmptyInfo() {
      this._emptyText = _.dataset(this.$root, VGCart.datasets.CART_EMPTY_TEXT);
      this._emptyButtonUrl = _.dataset(
        this.$root,
        VGCart.datasets.CART_EMPTY_BUTTON_URL
      );
      this._emptyButtonText = _.dataset(
        this.$root,
        VGCart.datasets.CART_EMPTY_BUTTON_TEXT
      );
    }

    /**
     * 绑定事件
     */
    _bindEvents() {
      _.on(document, "click", this._handleBehavior.bind(this));
      _.eventBus.on(VGCart.events.ADD, this._addCartItem.bind(this));
      _.eventBus.on(VGCart.events.UPDATE, this._updateCartItem.bind(this));
      _.eventBus.on(VGCart.events.REMOVE, this._removeCartItem.bind(this));
      _.eventBus.on(VGCart.events.OPEN_DRAWER, this._openDrawer.bind(this));
    }

    /**
     * 获取会员卡信息
     */
    async _fetchMemberCardInfo() {
      try {
        const timestamp = Math.floor(Date.now() / 1000);
        const payload = {
          timestamp,
          hash: window.CryptoJS.MD5(timestamp + "toGRkVSDP3MEfhcu").toString(),
          customer_id: window.customer_id,
          mail: window.customer_email,
          cart_lines: [...this._itemsMap.values()].map((item) =>
            JSON.parse(item.source)
          ),
          subtotalAmount: _.dataset(this.$root, "cartSubtotal"),
        };
        const response = await _.fetch.postJSON(
          "/checkout-api/getMainLabel",
          payload
        );
        const result = await response.json();

        if (this._isCartPage) {
          this._renderCartMember(result.data);
        } else {
          this._renderCartDrawerMemberCardMessage(result.data);
        }

        // 设置推荐的会员卡ID
        this._currentRecommendedMemberId = +result.data.member_id;
        // 设置推荐的会员卡是否显示
        this._isRecommendedMemberCardShow = !!result.data.is_show;

        // 如果推荐的会员卡不在购物车中，则显示会员卡
        if (
          !this._checkRecommendedMemberCardInCart() &&
          this._isRecommendedMemberCardShow
        ) {
          _.addClass(this.$member, "is-visible");
          _.on(
            this.$member,
            "click",
            this._handleAddMemberCardToCart.bind(this)
          );
        }
      } catch (error) {
        const { message } = JSON.parse(error.data);
        // @ts-ignore
        VogUtils.showMessage(message, "error");
      }
    }

    /**
     * 渲染购物车抽屉会员卡消息
     *
     * @param {*} data
     */
    _renderCartDrawerMemberCardMessage(data) {
      const $element = _.$(VGCart.selectors.CART_MEMBER_TITLE, this.$member);

      $element.innerHTML = `Join ${data.level} Member — <span class="vograce-cart-drawer__member-title-2">Extra</span> <span class="vograce-cart-drawer__member-title-amount">${Number(data.discount)}%</span> <span class="vograce-cart-drawer__member-title-2">Off+ More Perks</span>`;
    }

    /**
     * 构建购物车会员卡
     *
     * @param {any} data
     * @returns
     */
    _renderCartMember(data) {
      if (data.is_show == 0) return;

      const memberCard = VGCart.memberCards[data.level];

      const snippet = `
        <div class="flex">
          <img src="${memberCard.imageUrl}" class="vograce-cart__member-image" />
          <div class="vograce-flex vograce-flex-col vograce-flex-1">
          <h6 class="vograce-typography vograce-cart__member-title">${memberCard.title}</h6>
          <p class="vograce-typography vograce-cart__member-description skip-convert">Get Extra <span>${data.discount}%</span> Off Discount Every Order</p>
          <p class="vograce-typography vograce-cart__member-description skip-convert"><span>${data.price}</span> Yearly New Arrivals Coupons</p>
          <p class="vograce-typography vograce-cart__member-description skip-convert"><span>1.5x</span> Points Rewards <a href="${memberCard.url}" class="vograce-button vograce-button--link vograce-button--primary" target="_blank">Learn More</a></p>
          <div class="vograce-flex vograce-justify-between vograce-items-center">
            <span class="vograce-typography vograce-cart__member-price skip-convert" data-cart-member="price">$${data.price}/Year</span>
            <button class="vograce-button vograce-button--default vograce-button--solid vograce-button--block vograce-button--square vograce-cart__member-button" data-behavior="add-member-card-to-cart">
              <span>Add to Cart</span>
            </button>
          </div>
        </div>
        </div>
      `;

      this.$member.innerHTML = snippet;
    }

    /**
     * 检查推荐的会员卡是否在购物车中
     *
     * @returns {boolean}
     */
    _checkRecommendedMemberCardInCart() {
      return [...this._itemsMap.values()].some(
        (item) => item.vid === this._currentRecommendedMemberId
      );
    }

    /**
     * 打开抽屉
     *
     * @param {Object} options 选项
     * @param {boolean} options.refresh 是否刷新购物车
     */
    _openDrawer({ refresh = false }) {
      if (refresh) {
        this._fetchCartItems();
      }
      _.eventBus.emit("vograce:drawer:open", "#VograceCartDrawer");
    }

    /**
     * 处理添加会员卡到购物车
     *
     * @param {MouseEvent} e 事件对象
     */
    async _handleAddMemberCardToCart(e) {
      const target = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.ADD_MEMBER_CARD_TO_CART
      );
      if (!target) return;

      this._showLoading("Adding member card to cart...");
      this._changeCartItems("/cart/add.js", {
        id: this._currentRecommendedMemberId,
        quantity: 1,
      });
      _.off(this.$member, "click", this._handleAddMemberCardToCart.bind(this));
      _.removeClass(this.$member, "is-visible");
    }

    /**
     * 处理行为
     *
     * @param {MouseEvent} e 事件对象
     */
    _handleBehavior(e) {
      const moreOptionsTarget = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.SHOW_MORE_OPTIONS
      );
      if (moreOptionsTarget) {
        this._showMoreOptions(/** @type {HTMLElement} */ (moreOptionsTarget));
        return;
      }

      const deleteConfirmTarget = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.SHOW_DELETE_CONFIRM
      );
      if (deleteConfirmTarget) {
        this._showDeleteConfirm(
          /** @type {HTMLElement} */ (deleteConfirmTarget)
        );
        return;
      }

      const discountsTarget = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.SHOW_DISCOUNTS
      );
      if (discountsTarget) {
        this._showDiscounts(/** @type {HTMLElement} */ (discountsTarget));
        return;
      }

      const checkoutTarget = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.CHECKOUT
      );
      if (checkoutTarget) {
        this._navigateToCheckout();
        return;
      }

      const toggleDiscountDetailsTarget = /** @type {HTMLElement} */ (
        e.target
      ).closest(VGCart.behaviors.TOGGLE_DISCOUNT_DETAILS);
      if (toggleDiscountDetailsTarget) {
        this._toggleDiscountDetails();
        return;
      }
    }
    /**
     * 处理切换折扣详情
     * @returns {void}
     */
    _toggleDiscountDetails() {
      const element = _.$(VGCart.selectors.CART_CHECKOUT_DISCOUNT);
      if (!element) return;
      element.classList.toggle("is-expanded");
      this._isDiscountDetailsExpanded = !this._isDiscountDetailsExpanded;
    }

    /**
     * 处理跳转至结算页面
     */
    async _navigateToCheckout() {
      this._showLoading("Redirecting to checkout...");

      const gaUser = _.$("#GA_USER");
      const gaSession = _.$("#GA_SESSION");
      const cartNote = _.$("#CartNode");

      const formData = new URLSearchParams();
      formData.append("attributes[ga_user]", _.dataset(gaUser, "value"));
      formData.append("attributes[ga_session]", _.dataset(gaSession, "value"));
      // @ts-ignore
      formData.append("note", cartNote ? cartNote.value : "");

      await _.fetch.post("/cart", formData.toString(), {
        baseUrl: window.location.origin,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      window.location.href = "/checkout";
    }

    /**
     * 显示加载动画
     *
     * @param {string} text 加载动画文本
     */
    _showLoading(text) {
      this._isLoading = true;
      _.showLoading({ target: this.$root, text });
    }

    /**
     * 隐藏加载动画
     */
    _hideLoading() {
      if (!this._isLoading) return;
      this._isLoading = false;
      _.hideLoading(this.$root);
    }

    /**
     * 处理添加到购物车行为
     *
     * @param {MouseEvent} e 事件对象
     */
    async _addCartItem(e) {
      const form = /** @type {HTMLElement} */ (e.target).closest(
        VGCart.behaviors.ADD_TO_CART
      );
      if (!form) return;

      e.preventDefault();
      this._showLoading("Adding to cart...");
      const payload = {};
      new FormData(/** @type {HTMLFormElement} */ (form)).forEach(
        (value, key) => {
          if (key === 'vg-quantity') {
            payload['quantity'] = value;
          } else {
            payload[key] = value;
          }
        }
      );

      this._changeCartItems("/cart/add.js", payload);
    }

    /**
     * 更新购物车商品
     *
     * @param {string} id
     * @param {number} quantity
     */
    async _updateCartItem(id, quantity) {
      this._showLoading("Updating cart item quantity...");
      this._changeCartItems(`/cart/change.js?t=${Date.now()}`, {
        id,
        quantity,
      });
    }

    /**
     * 移除购物车商品
     *
     * @param {string} id
     */
    async _removeCartItem(id) {
      this._showLoading("Removing from cart...");
      this._changeCartItems(
        `/cart/change.js?t=${Date.now()}&id=${id}&quantity=0`
      );
    }

    /**
     * 修改购物车商品
     *
     * @param {string} url
     * @param {any} data
     */
    async _changeCartItems(url, data) {
      try {
        await _.fetch.postJSON(url, data, {
          baseUrl: window.location.origin,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        });
      } catch (error) {
        const { message } = JSON.parse(error.data);
        // @ts-ignore
        VogUtils.showMessage(message, "error");
      } finally {
        this._fetchCartItems();
      }
    }

    /**
     * 刷新运费和生产估算
     *
     * @private
     */
    async _refreshEstimate() {
      _.eventBus.emit("vograce:shipping-and-production-estimate:refresh");
    }

    /**
     * 获取购物车商品
     */
    async _fetchCartItems() {
      try {
        this._showLoading("Fetching cart items...");

        const {
          discounts = [],
          items = [],
          subtotal = 0,
          total_price: totalPrice = 0,
          total_discount: totalDiscount = 0,
        } = await _.fetch
          .get("/cart?view=metafields&t=" + Date.now(), {
            baseUrl: window.location.origin,
          })
          .then((r) => r.clone().text())
          .then((r) => JSON.parse(r));

        const cartItems = this._transformCartItems(items);

        this._itemsMap.clear();
        cartItems.forEach((item) => this._itemsMap.set(item.key, item));
        this._itemsCount = this._itemsMap.size;

        // 检查推荐的会员卡是否在购物车中
        if (
          !this._checkRecommendedMemberCardInCart() &&
          this._isRecommendedMemberCardShow
        ) {
          _.addClass(this.$member, "is-visible");
          _.on(
            this.$member,
            "click",
            this._handleAddMemberCardToCart.bind(this)
          );
        }

        // 渲染商品
        this._renderCartItemsCount(this._itemsCount);
        this._renderCartItems(cartItems);
        this._renderTotalPriceAndDiscount(
          totalPrice,
          totalDiscount,
          subtotal,
          discounts
        );

        // 重新初始化购物车抽屉计数器
        this.setupCartCounters();
        this._hideLoading();

        // 刷新运费和生产估算
        this._refreshEstimate();
      } catch (error) {
        console.log(error);
        const { message } = JSON.parse(error.data);
        // @ts-ignore
        VogUtils.showMessage(message, "error");
      } finally {
        this._hideLoading();
      }
    }

    /**
     * 展开商品选项
     *
     * @param {HTMLElement} element
     */
    _showMoreOptions(element) {
      const id = _.dataset(element, "expandedKey");
      const target = _.getSiblingElement(
        element,
        VGCart.selectors.CART_ITEM_OPTIONS
      );

      this._expandedKeys.add(id);
      _.addClass(target, "is-expanded");
      element.remove();
    }

    /**
     * 打开删除确认弹窗
     *
     * @param {HTMLElement} element
     */
    _showDeleteConfirm(element) {
      const id = _.dataset(element, "target");
      const cartItem = this._itemsMap.get(id);

      _.showPopup({
        id: `DeleteConfirm-${id}`,
        width: 540,
        title: "Are you sure you want to delete this item?",
        content: `
          <div class="vograce-cart-item-delete-confirm">
            <div class="vograce-cart-item-delete-confirm__image-wrapper">
              <img src="${
                cartItem.imageUrl
              }" class="vograce-cart-item-delete-confirm__image" />
            </div>
            <div class="vograce-cart-item-delete-confirm__meta">
              <h4 class="vograce-cart-item-delete-confirm__title">${
                cartItem.title
              }</h4>
              <span class="vograce-cart-item-delete-confirm__price">
                <span>$</span>
                <span>${(cartItem.price / 100).toFixed(2)}</span>
              </span>
            </div>
          </div>
        `,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        showConfirmButton: true,
        confirmButtonText: "Confirm",
        onConfirm: (close) => {
          this._removeCartItem(id);
          close();
        },
        onCancel: (close) => {
          close();
        },
      });
    }

    /**
     * 打开数量折扣弹窗
     *
     * @param {HTMLElement} element
     */
    _showDiscounts(element) {
      const id = _.dataset(element, "target");
      const { discounts, price } = this._itemsMap.get(id);

      const buildBody = () => {
        return discounts.map((item) => {
          const digits = (price * (100 - item.d)) / 10000;
          const digitsFixed = digits.toFixed(2);

          return `
            <div class="vograce-cart-discounts__row">
              <span class="vograce-cart-discounts__col">${item.m}+</span>
              <span class="vograce-cart-discounts__col">${item.d}% off</span>
              <span class="vograce-cart-discounts__col skip-convert">$${digitsFixed}</span>
            </div>
          `;
        });
      };

      _.showPopup({
        id: `Discount-${id}`,
        width: 800,
        title: "Buy at discounted prices",
        content: `
          <div class="vograce-cart-discounts">
            <div class="vograce-cart-discounts__row vograce-cart-discounts__head">
              <span class="vograce-cart-discounts__col">Minimum Qty</span>
              <span class="vograce-cart-discounts__col">Discount</span>
              <span class="vograce-cart-discounts__col skip-convert">Price</span>
            </div>
            ${buildBody().join("")}
          </div>
        `,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }

    /**
     * 转换单个购物车商品
     *
     * @param {ShopifyCartItem} item
     * @param {Array<ShopifyCartItemDiscount>} [discounts]
     * @returns {VGCartItem}
     */
    _transformSingleCartItem(item, discounts) {
      return {
        id: item.id,
        key: item.key,
        handle: item.handle,
        imageUrl: item.image,
        url: this._removeQueryParam(item.url, 'variant'),
        vid: item.variant_id,
        pid: item.product_id,
        title: item.product_title,
        options: item.options_with_values,
        originalPrice: item.original_price,
        price: item.price,
        originalLinePrice: item.original_line_price,
        linePrice: item.line_price,
        quantity: item.quantity,
        source: JSON.stringify(item),
        discounts: (discounts ? discounts : item.product_discounts) || [],
        properties: item.properties,
      };
    }

    /**
     * 从 URL 中移除指定的查询参数
     * @param {string} url - 原始 URL
     * @param {string|string[]} paramNames - 要移除的参数名（支持单个或多个）
     * @returns {string} 清理后的 URL
     */
    _removeQueryParam(url, paramNames) {
      // 确保 paramNames 是数组
      const paramsToRemove = Array.isArray(paramNames) ? paramNames : [paramNames];

      // 创建 URL 对象（自动处理 hash 和 search）
      const urlObj = new URL(url, window.location.origin); // 第二个参数用于处理相对路径

      // 遍历要删除的参数并移除
      paramsToRemove.forEach(param => {
        urlObj.searchParams.delete(param);
      });

      // 重建 URL（searchParams 会自动编码）
      let cleanedUrl = urlObj.origin + urlObj.pathname + urlObj.search;

      // 如果有 hash，也加上
      if (urlObj.hash) {
        cleanedUrl += urlObj.hash;
      }

      return cleanedUrl;
    }

    /**
     * 转换购物车商品集
     *
     * @param {Array<ShopifyCartItem>} items
     * @returns {Array<VGCartItem>}
     */
    _transformCartItems(items) {
      return items.map((item) => this._transformSingleCartItem(item));
    }

    /**
     * 渲染购物车商品数量
     *
     * @param {number} itemsCount
     */
    _renderCartItemsCount(itemsCount) {
      if (!this.$itemsCount) return;
      this.$itemsCount.textContent = `View My Cart (${itemsCount})`;
    }

    /**
     * 渲染购物车商品
     *
     * @param {Array<VGCartItem>} cartItems
     */
    _renderCartItems(cartItems) {
      this.$items.innerHTML =
        cartItems.length === 0
          ? this._buildCartItemsEmpty()
          : cartItems.map((item) => this._buildCartItem(item)).join("");
    }

    /**
     * 构建购物车空商品列表提示信息
     *
     * @returns {string}
     */
    _buildCartItemsEmpty() {
      return `
        <div class="vograce-cart-empty">
          <img src="https://cdn.shopify.com/s/files/1/0336/9297/5240/files/cart-drawer-items-empty.svg?v=1757923428" />
          <p class="vograce-typography">${this._emptyText}</p>
          <a href="${this._emptyButtonUrl}" class="vograce-button vograce-button--primary vograce-button--solid vograce-button--large vograce-button--square vograce-cart-empty__button" target="_self" rel="noopener noreferrer">
            <span>${this._emptyButtonText}</span>
          </a>
        </div>
      `;
    }

    /**
     * 构建购物车商品
     *
     * @param {VGCartItem} item
     */
    _buildCartItem(item) {
      const {
        key,
        imageUrl,
        url,
        pid,
        vid,
        title,
        options,
        quantity,
        discounts,
        properties,
        source,
      } = item;

      return `
        <div
          class="vograce-cart-item ${this._classPrefix}__item"
          data-cart-item="root"
          data-cart-item-id="${key}"
          data-cart-item-product-id="${pid}"
          data-cart-item-variant-id="${vid}"
          data-cart-item-graphql-variant-id="gid://shopify/ProductVariant/${vid}"
          data-cart-item-quantity="${quantity}"
          data-cart-item-original-price="${item.originalLinePrice}"
          data-cart-item-final-price="${item.linePrice}"
          data-cart-item-discounts="${JSON.stringify(discounts)}"
          data-cart-item-source="${source}"
        >
          <div class="vograce-cart-item__main">
            <a href="${url}" class="vograce-flex vograce-flex-0 vograce-overflow-hidden">
              <div class="vograce-image vograce-cart-item__image">
                <img src="${imageUrl}" class="vograce-image__inner" />
              </div>
            </a>
            <div class="vograce-cart-item__meta${
              this._isCartPage ? "" : " is-drawer"
            }">
              <div class="vograce-flex vograce-flex-col vograce-flex-1 vograce-cart-item__options-wrapper">
                <a href="${url}" class="vograce-typography vograce-line-clamp-2 vograce-cart-item__name">
                  ${title}
                </a>
                ${this._buildCartItemOptionsWithProperties(
                  `${pid}:${vid}`,
                  options,
                  properties
                )}
              </div>
              ${
                this._isCartPage
                  ? this._buildCartItemBottom(item)
                  : this._buildCartItemDrawerBottom(item)
              }
            </div>
          </div>
          ${this._buildCartItemDiscountsButton(key, quantity, discounts)}
        </div>
      `;
    }

    /**
     * 构建购物车抽屉底部
     *
     * @param {VGCartItem} item
     */
    _buildCartItemBottom(item) {
      const {
        key,
        quantity,
        price,
        originalPrice,
        linePrice,
        originalLinePrice,
      } = item;

      return `
        <div class="vograce-cart-item__extra--mobile">
          ${this._buildCartItemDrawerBottom(item)}
        </div>
        <div class="vograce-cart-item__extra--desktop">
          <div class="vograce-flex vograce-flex-col vograce-items-end vograce-cart-item__actions">
            ${this._buildCartItemCounter(key, quantity)}
            <div class="vograce-cart-item__price">
              ${this._buildCartItemPrice(price, originalPrice)}
            </div>
            <div class="vograce-flex vograce-items-center vograce-cart-item__price">
              <span class="vograce-typography vograce-cart-item__price-label">Total:</span>
              ${this._buildCartItemPrice(linePrice, originalLinePrice)}
            </div>
            ${this._buildCartItemDeleteButton(key)}
          </div>
        </div>
      `;
    }

    /**
     * 构建购物车抽屉底部
     *
     * @param {VGCartItem} item
     */
    _buildCartItemDrawerBottom(item) {
      const {
        key,
        quantity,
        price,
        originalPrice,
        linePrice,
        originalLinePrice,
      } = item;

      return `
        <div class="vograce-flex vograce-justify-between vograce-items-center vograce-cart-item__actions">
          ${this._buildCartItemCounter(key, quantity)}
          ${this._buildCartItemDeleteButton(key)}
        </div>
        <div class="vograce-flex vograce-justify-between vograce-items-center vograce-cart-item__price">
          ${this._buildCartItemPrice(price, originalPrice)}
          <div class="vograce-flex vograce-justify-between vograce-items-center">
            <span class="vograce-typography vograce-cart-item__price-label">Total:</span>
            ${this._buildCartItemPrice(linePrice, originalLinePrice)}
          </div>
        </div>
      `;
    }

    /**
     * 构建购物车商品选项和属性
     *
     * @param {string} key
     * @param {Array<ShopifyCartItemOptionWithValue>} options
     * @param {ShopifyCartItemProperties} properties
     * @returns {string}
     */
    _buildCartItemOptionsWithProperties(key, options, properties) {
      if (options.length === 0) return "";

      const optionSnippets = options.map((option) => {
        return `
          <div class="vograce-flex" title="${option.value}" style="width: 100%">
            <span class="vograce-typography vograce-flex-0 vograce-cart-item__property-label">${option.name}</span>
            <span class="vograce-typography vograce-flex-1 vograce-truncate vograce-cart-item__property-value">${option.value}</span>
          </div>
        `;
      });

      const isExpanded = this._isCartPage || this._expandedKeys.has(key);
      let expandedButtonSnippet = "";

      if (!isExpanded && options.length > 2) {
        expandedButtonSnippet = `
          <button
            type="button"
            class="
              vograce-button
              vograce-button--primary
              vograce-button--text
              vograce-cart-item__more-options-button
            "
            data-behavior="show-more-options"
            data-expanded-key="${key}"
            aria-label="Show more options"
            title="Show more options"
          >
            More
          </button>
        `;
      }

      return `
        <div class="vograce-cart-item__options${
          isExpanded ? " is-expanded" : ""
        }" data-cart-item="options">
          ${optionSnippets.join("")}
          ${this._buildCartItemProperties(properties)}
        </div>
        ${expandedButtonSnippet}
      `;
    }

    /**
     * 图片文件类型
     *
     * @type {Array<string>}
     * @readonly
     * @static
     * @constant
     */
    static FILE_TYPES = [
      "jpg",
      "jpeg",
      "webp",
      "gif",
      "png",
      "apng",
      "avif",
      "svg",
      "bmp",
      "ico",
      "tiff",
    ];

    /**
     * 构建购物车商品属性
     *
     * @param {ShopifyCartItemProperties} properties
     * @returns {string}
     */
    _buildCartItemProperties(properties) {
      if (Object.keys(properties).length === 0) return "";

      const normalProperties = [];
      const imageUrls = [];
      const proofImageUrls = [];

      properties.forEach(([propertyKey, propertyValue]) => {
        const firstCharacterInKey = propertyKey.charAt(0);
        if (firstCharacterInKey === "-" || firstCharacterInKey === "_") return;

        if (propertyKey === "Proof") {
          proofImageUrls.push(propertyValue);
        } else if (_.isString(propertyValue)) {
          const paths = propertyValue.toLowerCase().split(".");
          const ext = paths[paths.length - 1];
          if (VGCart.FILE_TYPES.includes(ext)) {
            imageUrls.push(propertyValue);
          } else {
            normalProperties.push([propertyKey, propertyValue]);
          }
        } else {
          normalProperties.push([propertyKey, propertyValue]);
        }
      });

      return `
        ${this._buildCartItemNormalProperties(normalProperties)}
        ${
          proofImageUrls.length > 0
            ? this._buildCartItemImageProperties(proofImageUrls, "Proof")
            : ""
        }
        ${
          imageUrls.length > 0
            ? this._buildCartItemImageProperties(imageUrls)
            : ""
        }
      `;
    }

    /**
     * 构建购物车商品普通属性
     *
     * @param {ShopifyCartItemProperties} properties
     * @returns {string}
     */
    _buildCartItemNormalProperties(properties) {
      const snippets = properties.map(([propertyKey, propertyValue]) => {
        return `
          <div class="vograce-flex" title="${propertyValue}" style="width: 100%">
            <span class="vograce-typography vograce-flex-0 vograce-cart-item__property-label">${propertyKey}</span>
            <span class="vograce-typography vograce-flex-1 vograce-truncate vograce-cart-item__property-value">${propertyValue}</span>
          </div>
        `;
      });

      return snippets.join("");
    }

    /**
     * 构建购物车商品图片属性
     *
     * @param {Array<string>} imageUrls 图片 URL 列表
     * @param {string} label
     * @returns {string}
     */
    _buildCartItemImageProperties(imageUrls, label = "Uploaded artwork") {
      const imageSnippets = imageUrls.map((imageUrl, index) => {
        return `
          <figure
            role="button"
            class="vograce-gallery"
            data-vg-trigger="gallery"
            data-src="${imageUrl}"
            tabindex="0"
            aria-label="View artwork ${index} in gallery"
          >
            <img
              class="vograce-gallery__thumbnail"
              src="${imageUrl}"
              width="50"
              height="50"
              alt="Uploaded artwork preview ${index}"
              loading="lazy"
            >
          </figure>
        `;
      });

      return `
        <div class="vograce-flex vograce-flex-col" aria-labelledby="uploaded-artwork-label">
          <div id="uploaded-artwork-label" class="vograce-typography vograce-cart-item__property-label">
            ${label}
          </div>
          <div class="vograce-cart-item__property-content vograce-gallery__container">
            ${imageSnippets.join("")}
          </div>
        </div>
      `;
    }

    /**
     * 构建购物车商品计数器
     *
     * @param {string} id
     * @param {number} quantity
     * @returns {string}
     */
    _buildCartItemCounter(id, quantity) {
      return `
        <div
          class="vograce-counter vograce-cart-item__counter"
          data-counter="root"
          data-counter-max="9999"
          data-counter-min="0"
          data-counter-step="1"
          data-counter-inside="true"
          data-counter-updatable="true"
          data-counter-removable="true"
          data-target="${id}"
        >
          <button type="button" class="vograce-counter__button" data-behavior="decrement">
            ${_.Icon("minus")}
          </button>
          <input type="text" name="vg-quantity" class="vograce-counter__input" data-counter="input" value="${quantity}">
          <button type="button" class="vograce-counter__button" data-behavior="increment">
            ${_.Icon("plus")}
          </button>
        </div>
      `;
    }

    /**
     * 构建购物车商品价格
     *
     * @param {number} price
     * @param {number} originalPrice
     * @returns {string}
     */
    _buildCartItemPrice(price, originalPrice) {
      const fixedOriginalPrice = (originalPrice / 100).toFixed(2);
      const fixedPrice = (price / 100).toFixed(2);

      let originalPriceSnippet = "";
      if (originalPrice > price) {
        originalPriceSnippet = `<span class="vograce-typography vograce-price__original">$${fixedOriginalPrice}</span>`;
      }

      return `
        <span class="vograce-price vograce-price--reverse">
          ${originalPriceSnippet}
          <span class="vograce-typography vograce-price__current">$${fixedPrice}</span>
        </span>
      `;
    }

    /**
     * 构建购物车商品删除按钮
     *
     * @param {string} id
     * @returns {string}
     */
    _buildCartItemDeleteButton(id) {
      return _.createElement(
        "button",
        {
          type: "button",
          class: [
            "vograce-button",
            "vograce-button--default",
            "vograce-button--circle",
            "vograce-button--large",
            "vograce-button--text",
            "vograce-button--single-icon",
            "vograce-cart-item__delete-button",
          ].join(" "),
          data: {
            target: id,
            behavior: "show-delete-confirm",
          },
          aria: {
            label: "Delete this item",
          },
          title: "Delete this item",
        },
        _.Icon("delete")
      ).outerHTML;
    }

    /**
     * 构建购物车商品折扣按钮
     *
     * @param {string} id
     * @param {number} quantity
     * @param {Array<ShopifyCartItemDiscount>} discounts
     * @returns {string}
     */
    _buildCartItemDiscountsButton(id, quantity, discounts) {
      if (discounts.length === 0) return "";

      let offer;
      for (const discount of discounts) {
        if (quantity < discount.m) {
          offer = discount;
          break;
        }
      }

      if (!offer) return "";

      return `
        <button
          type="button"
          class="
            vograce-button
            vograce-button--default
            vograce-button--block
            vograce-button--text
            vograce-button--square
            vograce-cart-item__discounts-button
          "
          data-behavior="show-discounts"
          data-target="${id}"
          aria-label="Show available discounts"
          title="Show available discounts"
        >
          <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_12903_29856)">
              <path d="M20.0086 8.80971L19.3479 1.83203C19.3144 1.47042 19.0265 1.18471 18.6649 1.149L11.6872 0.488281H11.6783C11.6069 0.488281 11.5511 0.510603 11.5086 0.553013L1.05551 11.0061C1.03482 11.0268 1.0184 11.0513 1.0072 11.0783C0.996 11.1053 0.990234 11.1343 0.990234 11.1635C0.990234 11.1927 0.996 11.2217 1.0072 11.2487C1.0184 11.2757 1.03482 11.3002 1.05551 11.3209L9.17605 19.4414C9.21846 19.4838 9.27426 19.5061 9.33453 19.5061C9.3948 19.5061 9.4506 19.4838 9.49301 19.4414L19.9461 8.98828C19.9908 8.94141 20.0131 8.87667 20.0086 8.80971ZM9.3323 17.2003L3.29658 11.1646L12.2185 2.24275L17.7319 2.76507L18.2542 8.27846L9.3323 17.2003ZM14.2497 4.28292C13.1671 4.28292 12.2854 5.16462 12.2854 6.24721C12.2854 7.3298 13.1671 8.2115 14.2497 8.2115C15.3323 8.2115 16.214 7.3298 16.214 6.24721C16.214 5.16462 15.3323 4.28292 14.2497 4.28292ZM14.2497 6.9615C13.8546 6.9615 13.5354 6.6423 13.5354 6.24721C13.5354 5.85212 13.8546 5.53292 14.2497 5.53292C14.6448 5.53292 14.964 5.85212 14.964 6.24721C14.964 6.6423 14.6448 6.9615 14.2497 6.9615Z" fill="#333333" />
            </g>
            <defs>
              <clipPath id="clip0_12903_29856">
                <rect width="20" height="20" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
          <span>Buy ${offer.m} to get ${offer.d}% off each</span>
        </button>
      `;
    }

    /**
     * 渲染总价和折扣
     *
     * @param {number} totalPrice
     * @param {number} totalDiscount
     * @param {number} subtotal
     * @param {Array<ShopifyCartAppliedDiscount>} discounts
     */
    _renderTotalPriceAndDiscount(
      totalPrice = 0,
      totalDiscount = 0,
      subtotal = 0,
      discounts = []
    ) {
      const snippets = [];
      const fixedSubtotal = (subtotal / 100).toFixed(2);
      const fixedTotalPrice = (totalPrice / 100).toFixed(2);

      snippets.push(`
        <div class="vograce-flex vograce-justify-between vograce-items-center vograce-cart-checkout__item">
          <span class="vograce-typography vograce-cart-checkout__label">Order value</span>
          <span class="vograce-typography vograce-cart-checkout__value">$${fixedSubtotal}</span>
        </div>
      `);

      if (totalDiscount > 0) {
        if (discounts.length === 1) {
          const discountName = discounts[0].name;
          const discountAmount = (discounts[0].amount / 100).toFixed(2);
          snippets.push(`
            <div class="vograce-flex vograce-justify-between vograce-items-center vograce-cart-checkout__item">
              <span class="vograce-typography vograce-cart-checkout__label">${discountName}</span>
              <span class="vograce-typography vograce-cart-checkout__value vograce-cart-checkout__value--discount">
                $${discountAmount}
              </span>
            </div>
          `);
        } else {
          const discountCodes = [];
          const otherDiscounts = [];
          const fixedTotalDiscount = (totalDiscount / 100).toFixed(2);

          discounts.forEach((discount) => {
            if (discount.key === "discount_code") {
              discountCodes.push(discount);
            } else {
              otherDiscounts.push(discount);
            }
          });

          // 合并多条 PRODUCT DISCOUNT 为一条
          const productDiscounts = otherDiscounts.filter((discount) =>
            discount.name.includes("PRODUCT DISCOUNT")
          );
          const nonProductDiscounts = otherDiscounts.filter(
            (discount) => !discount.name.includes("PRODUCT DISCOUNT")
          );

          // 计算产品折扣总额
          const totalProductDiscountAmount = productDiscounts.reduce(
            (sum, discount) => sum + discount.amount,
            0
          );

          // 如果有产品折扣，创建合并后的产品折扣对象
          const mergedProductDiscount =
            productDiscounts.length > 0
              ? {
                  name: "PRODUCT DISCOUNT",
                  amount: totalProductDiscountAmount,
                }
              : null;

          // 重新构建 otherDiscounts 数组
          const sortedOtherDiscounts = [];
          if (mergedProductDiscount) {
            sortedOtherDiscounts.push(mergedProductDiscount);
          }

          // 对非产品折扣进行排序：PROMOTIONAL DISCOUNT -> VIP DISCOUNT -> 其他
          nonProductDiscounts.sort((a, b) => {
            const getSortOrder = (name) => {
              if (name.includes("PROMOTIONAL DISCOUNT")) return 1;
              if (name.includes("VIP DISCOUNT")) return 2;
              return 3; // 其他折扣排在最后
            };

            const orderA = getSortOrder(a.name);
            const orderB = getSortOrder(b.name);

            return orderA - orderB;
          });

          // 添加排序后的非产品折扣
          sortedOtherDiscounts.push(...nonProductDiscounts);

          // 更新 otherDiscounts 数组
          otherDiscounts.length = 0;
          otherDiscounts.push(...sortedOtherDiscounts);

          let discountDetailsToggleSnippet = "";
          if (!this._isCartPage) {
            discountDetailsToggleSnippet = `
              <span class="vograce-flex-1 vograce-cart-checkout__discount-details-toggle" data-behavior="toggle-discount-details">
                <span>View details</span>
                ${_.Icon("down")}
              </span>
            `;
          }

          const discountDetailsExpandedClass =
            this._isDiscountDetailsExpanded || this._isCartPage
              ? " is-expanded"
              : "";

          snippets.push(`
            <div class="vograce-cart-checkout__discount${discountDetailsExpandedClass}" data-cart-checkout="discount">
          `);

          snippets.push(`
            <div class="vograce-cart-checkout__discount-header">
              <span class="vograce-typography vograce-cart-checkout__label">Discounts</span>
              ${discountDetailsToggleSnippet}
              <span class="vograce-typography vograce-cart-checkout__value vograce-cart-checkout__value--discount">
                $${fixedTotalDiscount}
              </span>
            </div>
          `);

          otherDiscounts.forEach((otherDiscount) => {
            const fixedAmount = (otherDiscount.amount / 100).toFixed(2);

            snippets.push(`
              <div class="vograce-cart-checkout__discount-item">
                <span class="vograce-typography vograce-cart-checkout__discount-label">${otherDiscount.name}</span>
                <span class="vograce-typography vograce-cart-checkout__discount-value">$${fixedAmount}</span>
              </div>
            `);
          });

          if (discountCodes.length > 0) {
            snippets.push(`
              <div class="vograce-cart-checkout__discount-codes">
                <span class="vograce-typography vograce-cart-checkout__discount-label">Discount Codes</span>
                <div class="vograce-flex-1 vograce-flex vograce-flex-col vograce-items-stretch">
            `);

            discountCodes.forEach((discount) => {
              const fixedAmount = (discount.amount / 100).toFixed(2);

              snippets.push(`
                <div class="vograce-flex vograce-justify-end vograce-items-center vograce-cart-checkout__discount-code">
                  <span class="vograce-typography vograce-cart-checkout__discount-code-label">${discount.name}</span>
                  <span class="vograce-typography vograce-cart-checkout__discount-code-value">$${fixedAmount}</span>
                </div>
              `);
            });

            snippets.push(`</div></div>`);
          }

          snippets.push(`</div>`);
        }
      }

      snippets.push(`
        <div class="vograce-flex vograce-justify-between vograce-items-center vograce-cart-checkout__item">
          <span class="vograce-typography vograce-cart-checkout__label">Total</span>
          <span class="vograce-typography vograce-cart-checkout__value">$${fixedTotalPrice}</span>
        </div>
      `);

      this.$checkout.innerHTML = snippets.join("");
    }

    /**
     * 设置外部添加到购物车事件
     */
    setupExternalAddToCartListeners() {
      /**
       * 处理添加到购物车事件
       *
       * @param {SubmitEvent} e
       */
      const handler = (e) => {
        _.eventBus.emit(VGCart.events.ADD, e);
      };

      _.on(document, "submit", handler, true);
      _.logger.info("External add to cart handler initialized");
    }

    /**
     * 初始化购物车计数器
     */
    setupCartCounters() {
      if (window.__VOGRACE_COUNTER__.has("CART")) {
        const set = window.__VOGRACE_COUNTER__.get("CART");
        set.forEach((counter) => counter.destroy());
        set.clear();
      }
      const counters = VGCounter.getInstances(this.$root);
      const counterSet = new Set(counters);
      window.__VOGRACE_COUNTER__.set("CART", counterSet);
      _.logger.info("Cart counters initialized");
    }

    /**
     * 初始化
     *
     * @static
     */
    static setup() {
      const cart = new VGCart();
      cart.setupExternalAddToCartListeners();
      cart.setupCartCounters();
      _.logger.info("VGCart initialized");
    }
  }

  /**
   * 计数器
   */
  class VGCounter {
    static selectors = {
      ROOT: "[data-counter='root']",
      INPUT: "[data-counter='input']",
    };

    static behaviors = {
      DECREMENT: "[data-behavior='decrement']",
      INCREMENT: "[data-behavior='increment']",
    };

    /**
     * 默认配置
     *
     * @type {VGCounterConfig}
     * @constant
     */
    static DEFAULT_CONFIG = {
      max: Infinity,
      min: 0,
      step: 1,
      inside: true,
      updatable: true,
      removable: true,
    };

    /**
     * @constructor
     * @param {HTMLElement} root 根元素
     */
    constructor(root) {
      this.$root = root;
      this.$input = /** @type {HTMLInputElement} */ (
        _.$(VGCounter.selectors.INPUT, this.$root)
      );

      this._init();
    }

    _init() {
      // 获取配置
      this._config = this._getConfig();

      this._target = _.dataset(this.$root, "target");
      // 获取值
      this._value = +this.$input.value || this._config.min;

      // 防抖处理输入事件
      this._debouncedHandleInput = _.debounce(
        this._handleInput.bind(this),
        300
      );

      // 绑定输入事件
      _.on(this.$input, "input", this._debouncedHandleInput);
      // 绑定失焦事件
      _.on(this.$input, "blur", this._handleBlur.bind(this));
      // 绑定点击事件
      _.on(this.$root, "click", this._handleClickBehavior.bind(this));
    }

    /**
     * 获取配置
     *
     * @returns {VGCounterConfig}
     */
    _getConfig() {
      const defaults = { ...VGCounter.DEFAULT_CONFIG };

      const max = +_.dataset(this.$root, "counterMax") || Infinity;
      const min = +_.dataset(this.$root, "counterMin") || 0;
      const step = +_.dataset(this.$root, "counterStep") || 1;
      const inside = _.dataset(this.$root, "counterInside") === "true" || true;
      const updatable = _.dataset(this.$root, "counterUpdatable") === "true";
      const removable = _.dataset(this.$root, "counterRemovable") === "true";

      return Object.assign(defaults, {
        max,
        min,
        step,
        inside,
        updatable,
        removable,
      });
    }

    /**
     * 处理点击行为
     *
     * @param {MouseEvent} e
     */
    _handleClickBehavior(e) {
      const increment = /** @type {Element} */ (e.target).closest(
        VGCounter.behaviors.INCREMENT
      );
      if (increment) {
        this._increment();
        return;
      }

      const decrement = /** @type {Element} */ (e.target).closest(
        VGCounter.behaviors.DECREMENT
      );
      if (decrement) {
        this._decrement();
        return;
      }
    }

    /**
     * 处理输入事件
     *
     * @param {InputEvent} e
     */
    _handleInput(e) {
      let value = /** @type {HTMLInputElement} */ (e.target).value;

      // 只保留数字字符
      value = value.replace(/[^0-9]/g, "");

      // 如果为空或者不是有效数字，设置为1
      if (value === "" || isNaN(+value)) {
        value = "1";
      }

      // 转换为数字
      let numValue = parseInt(value, 10);

      if (this._config.removable && numValue === 0) {
        this._removeCartItem();
        return;
      }

      // 更新值
      this._value = numValue;

      // 启用失焦更新
      this._shouldUpdate = true;
    }

    /**
     * 处理失焦事件
     */
    _handleBlur() {
      if (this._shouldUpdate) {
        this.$input.value = this._value.toString();
        this._shouldUpdate = false;
        this._updateCartItem();
      }
    }

    /**
     * 增加值
     */
    _increment() {
      if (this._value === this._config.max) return;
      this._value += this._config.step;
      this.$input.value = this._value.toString();

      this._config.updatable && this._updateCartItem();
    }

    /**
     * 减少值
     */
    _decrement() {
      if (this._value === this._config.min) return;
      this._value -= this._config.step;
      this.$input.value = this._value.toString();

      if (this._value === 0) {
        this._config.removable && this._removeCartItem();
        return;
      }

      this._config.updatable && this._updateCartItem();
    }

    /**
     * 更新购物车商品
     */
    _updateCartItem() {
      if (!this._config.inside || !this._config.updatable) return;
      _.eventBus.emit(VGCart.events.UPDATE, this._target, this._value);
    }

    /**
     * 移除购物车商品
     */
    _removeCartItem() {
      // 通知移除商品
      _.eventBus.emit(VGCart.events.REMOVE, this._target);

      this.destroy();
    }

    destroy() {
      // 解除事件绑定
      _.off(this.$input, "input", this._handleInput.bind(this));
      _.off(this.$root, "click", this._handleClickBehavior.bind(this));

      // 解除引用
      this.$root = null;
      this.$input = null;
    }

    /**
     * 初始化
     *
     * @param {HTMLElement} [parent] 父元素
     * @returns {VGCounter[]}
     */
    static getInstances(parent) {
      return Array.from(_.$$(VGCounter.selectors.ROOT, parent)).map((el) => {
        return new VGCounter(el);
      });
    }
  }

  _.ready(() => {
    VGCart.setup();
    VGSlider.setup();

    window.Fancybox.bind("[data-vg-trigger='gallery']");
  });
});

/**
 * ======================================
 * ======= BCPO Proxy
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  _.ready(() => {
    whenBcpoReady(async (bcpo) => {
      await _.wait(5000);
      bcpo.$(document).on("bcpo:afterAdd", function () {
        window.navigateToCartOrOpenCartDrawer();
        return true;
      });
    });
  });

  /**
   * 安全等待 bcpo 加载
   * @param {(bcpo: any) => void} fn 回调函数
   */
  function whenBcpoReady(fn) {
    if (window.bcpo && window.bcpo.$) {
      fn(window.bcpo);
    } else {
      let attempts = 0;
      const max = 30; // 最多等 3 秒（30 * 100ms）
      const check = () => {
        if (window.bcpo && window.bcpo.$) {
          fn(window.bcpo);
        } else if (attempts++ < max) {
          setTimeout(check, 100);
        } else {
          console.error("bcpo failed to load");
        }
      };
      setTimeout(check, 0); // 异步启动
    }
  }
});

/**
 * ======================================
 * ======= DPO Proxy
 * ======================================
 */
window.__VOGRACE__.sandbox((/** @type {VGSDKWithComponents} */ _) => {
  _.ready(() => {
    window.$vog.eventEmitter.on("dpo_initialized", function () {
      console.log("dpo_initialized");
      window.dpoOptions.asyncAddToCartCallback = asyncAddToCartCallback;
      window.dpoOptions.asyncAddToCartPostCheck = asyncAddToCartPostCheck;
    });
  });

  /**
   * 处理异步添加到购物车回调
   * @param {any} data
   * @param {number} n
   */
  function asyncAddToCartCallback(data, n) {
    _.logger.info("asyncAddToCartCallback", data, n);
    if (n > 25) return window.navigateToCartOrOpenCartDrawer();

    window.jQuery.ajax({
      url: "/cart",
      method: "GET",
      async: false,
      success: function (cart) {
        var rows = window
            .jQuery(cart)
            .find(window.dpoObserver.selectors.cartTableRow),
          pass = true;
        rows.each(function () {
          if (
            this.innerHTML.indexOf("assets/no-image") > -1 ||
            this.innerHTML.indexOf('href=""') > -1
          )
            pass = false;
        });
        if (pass) window.navigateToCartOrOpenCartDrawer();
        else
          setTimeout(function () {
            window.dpoOptions.asyncAddToCartCallback(data, n ? n + 1 : 2);
          }, 1000);
      },
      error: function () {
        setTimeout(function () {
          window.dpoOptions.asyncAddToCartCallback(data, n ? n + 1 : 2);
        }, 1000);
      },
    });
  }

  /**
   * 处理异步添加到购物车后检查
   * @param {number} vId
   * @param {any} data
   * @param {number} n
   */
  function asyncAddToCartPostCheck(vId, data, n) {
    _.logger.info("asyncAddToCartPostCheck", vId, data, n);
    window.jQuery(".input-file").each(function () {
      // @ts-ignore
      if (this.prevName) this.name = this.prevName;
    });
    // 只在第一次调用时进行清理和重命名操作，避免递归调用时丢失元素
    if (!n || n <= 2) {
      window.jQuery('#dpo-cart-properties, [name="id"]').remove();
      window.jQuery('[name="id_prev"]').attr("name", "id");
    }
    if (n > 25) {
      window.navigateToCartOrOpenCartDrawer();
      return;
    }
    var cartProductUrl = window
      .jQuery(".dpo-cart")
      .closest(".has_dpo")
      .find('a[href*="/products"]')
      .prop("href");
    // @ts-ignore
    if ((!window.meta || !meta.product) && !cartProductUrl) {
      return window.dpoOptions.asyncAddToCartCallback(data);
    }
    var url = cartProductUrl ? cartProductUrl : document.location.href,
      p = url.indexOf("?");
    if (p > -1) url = url.substr(0, p);
    p = url.indexOf("#");
    if (p > -1) url = url.substr(0, p);
    window.jQuery.ajax({
      url: url + ".json",
      method: "GET",
      async: false,
      dataType: "json",
      success: function (product) {
        if (product.product.variants && product.product.variants.length) {
          var pass = false;
          window.jQuery.each(product.product.variants, function () {
            if (
              this.id - 0 == vId - 0 &&
              (!cartProductUrl ||
                !data ||
                Math.abs(data.price - this.price * 100) < 1)
            )
              pass = true;
          });
          setTimeout(function () {
            if (pass) {
              window.dpoOptions.asyncAddToCartCallback(data);
            } else {
              window.dpoOptions.asyncAddToCartPostCheck(
                vId,
                data,
                n ? n + 1 : 2
              );
            }
          }, 1000);
        }
      },
    });
  }
});
